var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscoverImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.71,
    height: 17.973,
    viewBox: "0 0 28.71 17.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38022",
    "data-name": "Path 38022",
    d: "M239.312,232.645a1.41,1.41,0,0,0-1.435,1.382,1.434,1.434,0,1,0,1.435-1.382Z",
    transform: "translate(-237.877 -232.645)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Discover_-_img",
    "data-name": "Discover - img",
    transform: "translate(-16.283 -106.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12939",
    "data-name": "Group 12939",
    transform: "translate(16.283 106.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38020",
    "data-name": "Path 38020",
    d: "M44.993,123.036a.954.954,0,0,1-.956.956H16.283V106.04h28.71Z",
    transform: "translate(-16.283 -106.04)",
    fill: "#fcfcfc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38021",
    "data-name": "Path 38021",
    d: "M147.973,285.317l20.828.022v-7.7c-1.905,1.214-9.1,5.381-20.828,7.68Z",
    transform: "translate(-140.091 -267.366)",
    fill: "#f58220",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12938",
    "data-name": "Group 12938",
    transform: "translate(13.263 7.578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12682",
    "data-name": "Group 12682",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4591",
    "data-name": "Rectangle 4591",
    width: 2.866,
    height: 2.801,
    fill: "#f48220"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12683",
    "data-name": "Group 12683",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38023",
    "data-name": "Path 38023",
    d: "M259.347,255.012c0-.005-.005-.005-.011-.005s-.006,0-.006.005,0,.011.006.011a.011.011,0,0,0,.011-.011Z",
    transform: "translate(-258.047 -253.668)",
    fill: "#ffeee1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12684",
    "data-name": "Group 12684",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38025",
    "data-name": "Path 38025",
    d: "M259.26,254.923c0,.005,0,.005-.005.005a.005.005,0,0,1-.006-.005l.006-.006a.005.005,0,0,1,.005.006Zm.011,0c0-.006-.011-.011-.016-.011a.012.012,0,0,0-.011.011c0,.005.005.016.011.016a.024.024,0,0,0,.016-.016Z",
    transform: "translate(-257.965 -253.579)",
    fill: "#ffeee1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12685",
    "data-name": "Group 12685",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38027",
    "data-name": "Path 38027",
    d: "M259.181,254.843a.011.011,0,1,1-.021,0,.011.011,0,1,1,.021,0Zm.011,0c0-.011-.011-.016-.022-.016a.014.014,0,0,0-.016.016c0,.011.006.022.016.022a.024.024,0,0,0,.022-.022Z",
    transform: "translate(-257.88 -253.499)",
    fill: "#ffeee0",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12686",
    "data-name": "Group 12686",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38029",
    "data-name": "Path 38029",
    d: "M259.1,254.757a.016.016,0,1,1-.032,0,.016.016,0,0,1,.032,0Zm.011,0a.024.024,0,0,0-.027-.022.023.023,0,0,0-.022.022.025.025,0,0,0,.022.027.025.025,0,0,0,.027-.027Z",
    transform: "translate(-257.793 -253.413)",
    fill: "#ffeddf",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12687",
    "data-name": "Group 12687",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38031",
    "data-name": "Path 38031",
    d: "M259.024,254.676a.022.022,0,0,1-.043,0,.022.022,0,1,1,.043,0Zm.011,0a.03.03,0,0,0-.032-.027.025.025,0,0,0-.027.027.03.03,0,0,0,.027.032.035.035,0,0,0,.032-.032Z",
    transform: "translate(-257.712 -253.332)",
    fill: "#ffeddf",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12688",
    "data-name": "Group 12688",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38033",
    "data-name": "Path 38033",
    d: "M258.948,254.588a.027.027,0,1,1-.027-.027.025.025,0,0,1,.027.027Zm.011,0a.036.036,0,0,0-.038-.032.035.035,0,0,0-.032.032.036.036,0,0,0,.032.038.037.037,0,0,0,.038-.038Z",
    transform: "translate(-257.631 -253.245)",
    fill: "#ffedde",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12689",
    "data-name": "Group 12689",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38035",
    "data-name": "Path 38035",
    d: "M258.86,254.5a.035.035,0,0,1-.032.033.032.032,0,1,1,.032-.033Zm.011,0a.042.042,0,0,0-.043-.038.037.037,0,0,0-.038.038.042.042,0,0,0,.038.043.046.046,0,0,0,.043-.043Z",
    transform: "translate(-257.538 -253.157)",
    fill: "#ffedde",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12690",
    "data-name": "Group 12690",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38037",
    "data-name": "Path 38037",
    d: "M258.783,254.42a.038.038,0,1,1-.038-.038.037.037,0,0,1,.038.038Zm.01,0a.044.044,0,0,0-.048-.043.04.04,0,0,0-.043.043.044.044,0,0,0,.043.049.048.048,0,0,0,.048-.049Z",
    transform: "translate(-257.456 -253.076)",
    fill: "#ffedde",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12691",
    "data-name": "Group 12691",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38039",
    "data-name": "Path 38039",
    d: "M258.708,254.334a.04.04,0,0,1-.043.043.043.043,0,0,1-.043-.043.046.046,0,0,1,.043-.043.042.042,0,0,1,.043.043Zm.011,0a.054.054,0,0,0-.054-.049.048.048,0,0,0-.048.049.053.053,0,0,0,.048.054.058.058,0,0,0,.054-.054Z",
    transform: "translate(-257.376 -252.99)",
    fill: "#ffedde",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12692",
    "data-name": "Group 12692",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38041",
    "data-name": "Path 38041",
    d: "M258.627,254.246a.048.048,0,1,1-.048-.049.048.048,0,0,1,.048.049Zm.011,0a.056.056,0,0,0-.059-.054.051.051,0,0,0-.054.054.056.056,0,0,0,.054.059.06.06,0,0,0,.059-.059Z",
    transform: "translate(-257.289 -252.902)",
    fill: "#ffecdd",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12693",
    "data-name": "Group 12693",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38043",
    "data-name": "Path 38043",
    d: "M258.547,254.165a.051.051,0,0,1-.054.054.054.054,0,0,1-.054-.054.058.058,0,0,1,.054-.054.055.055,0,0,1,.054.054Zm.01,0a.065.065,0,0,0-.065-.059.06.06,0,0,0-.059.059.065.065,0,0,0,.059.065.069.069,0,0,0,.065-.065Z",
    transform: "translate(-257.203 -252.822)",
    fill: "#ffecdd",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12694",
    "data-name": "Group 12694",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38045",
    "data-name": "Path 38045",
    d: "M258.471,254.079a.059.059,0,1,1-.059-.059.06.06,0,0,1,.059.059Zm.011,0a.067.067,0,0,0-.07-.065.062.062,0,0,0-.065.065.067.067,0,0,0,.065.07.071.071,0,0,0,.07-.07Z",
    transform: "translate(-257.122 -252.735)",
    fill: "#ffecdd",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12695",
    "data-name": "Group 12695",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38047",
    "data-name": "Path 38047",
    d: "M258.389,254a.065.065,0,1,1-.065-.065.062.062,0,0,1,.065.065Zm.011,0a.073.073,0,0,0-.076-.07.071.071,0,0,0-.07.07.073.073,0,0,0,.07.076A.074.074,0,0,0,258.4,254Z",
    transform: "translate(-257.034 -252.653)",
    fill: "#ffecdd",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12696",
    "data-name": "Group 12696",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38049",
    "data-name": "Path 38049",
    d: "M258.306,253.911a.07.07,0,1,1-.07-.07.071.071,0,0,1,.07.07Zm.011,0a.078.078,0,0,0-.081-.076.074.074,0,0,0-.076.076.079.079,0,0,0,.076.081.083.083,0,0,0,.081-.081Z",
    transform: "translate(-256.946 -252.567)",
    fill: "#ffecdd",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12697",
    "data-name": "Group 12697",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38051",
    "data-name": "Path 38051",
    d: "M258.231,253.824a.076.076,0,1,1-.076-.076.074.074,0,0,1,.076.076Zm.011,0a.084.084,0,0,0-.086-.081.083.083,0,0,0-.081.081.084.084,0,0,0,.081.086.085.085,0,0,0,.086-.086Z",
    transform: "translate(-256.866 -252.48)",
    fill: "#ffebdc",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12698",
    "data-name": "Group 12698",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38053",
    "data-name": "Path 38053",
    d: "M258.144,253.743a.081.081,0,1,1-.081-.081.083.083,0,0,1,.081.081Zm.011,0a.09.09,0,0,0-.092-.086.086.086,0,0,0-.087.086.09.09,0,0,0,.087.092.1.1,0,0,0,.092-.092Z",
    transform: "translate(-256.774 -252.399)",
    fill: "#ffebdc",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12699",
    "data-name": "Group 12699",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38055",
    "data-name": "Path 38055",
    d: "M258.068,253.657a.086.086,0,1,1-.086-.086.085.085,0,0,1,.086.086Zm.011,0a.092.092,0,0,0-.1-.092.088.088,0,0,0-.092.092.092.092,0,0,0,.092.1.1.1,0,0,0,.1-.1Z",
    transform: "translate(-256.692 -252.313)",
    fill: "#ffebdc",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12700",
    "data-name": "Group 12700",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38057",
    "data-name": "Path 38057",
    d: "M257.993,253.568a.092.092,0,1,1-.092-.092.095.095,0,0,1,.092.092Zm.011,0a.1.1,0,0,0-.1-.1.1.1,0,0,0-.1.1.1.1,0,0,0,.1.1.106.106,0,0,0,.1-.1Z",
    transform: "translate(-256.611 -252.225)",
    fill: "#ffebdc",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12701",
    "data-name": "Group 12701",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38059",
    "data-name": "Path 38059",
    d: "M257.911,253.488a.1.1,0,1,1-.1-.1.1.1,0,0,1,.1.1Zm.011,0a.1.1,0,0,0-.108-.1.1.1,0,0,0-.1.1.1.1,0,0,0,.1.108.108.108,0,0,0,.108-.108Z",
    transform: "translate(-256.524 -252.144)",
    fill: "#ffebda",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12702",
    "data-name": "Group 12702",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38061",
    "data-name": "Path 38061",
    d: "M257.829,253.4a.1.1,0,0,1-.1.1.1.1,0,0,1-.1-.1.106.106,0,0,1,.1-.1.1.1,0,0,1,.1.1Zm.011,0a.113.113,0,0,0-.113-.108.108.108,0,0,0-.108.108.113.113,0,0,0,.108.113.117.117,0,0,0,.113-.113Z",
    transform: "translate(-256.436 -252.056)",
    fill: "#ffebda",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12703",
    "data-name": "Group 12703",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38063",
    "data-name": "Path 38063",
    d: "M257.753,253.319a.108.108,0,1,1-.108-.108.108.108,0,0,1,.108.108Zm.011,0a.116.116,0,0,0-.119-.113.111.111,0,0,0-.113.113.115.115,0,0,0,.113.119.12.12,0,0,0,.119-.119Z",
    transform: "translate(-256.356 -251.975)",
    fill: "#ffeada",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12704",
    "data-name": "Group 12704",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38065",
    "data-name": "Path 38065",
    d: "M257.673,253.233a.111.111,0,0,1-.113.113.114.114,0,0,1-.113-.113.118.118,0,0,1,.113-.113.114.114,0,0,1,.113.113Zm.011,0a.121.121,0,0,0-.124-.119.12.12,0,0,0-.119.119.122.122,0,1,0,.243,0Z",
    transform: "translate(-256.27 -251.889)",
    fill: "#ffead9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12705",
    "data-name": "Group 12705",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38067",
    "data-name": "Path 38067",
    d: "M257.592,253.146a.119.119,0,1,1-.119-.119.12.12,0,0,1,.119.119Zm.01,0a.127.127,0,0,0-.129-.124.122.122,0,0,0-.124.124.127.127,0,0,0,.124.129.131.131,0,0,0,.129-.129Z",
    transform: "translate(-256.184 -251.802)",
    fill: "#ffead9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12706",
    "data-name": "Group 12706",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38069",
    "data-name": "Path 38069",
    d: "M257.515,253.065a.124.124,0,1,1-.124-.124.122.122,0,0,1,.124.124Zm.011,0a.132.132,0,1,0-.135.135.132.132,0,0,0,.135-.135Z",
    transform: "translate(-256.101 -251.722)",
    fill: "#ffead9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12707",
    "data-name": "Group 12707",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38071",
    "data-name": "Path 38071",
    d: "M257.432,252.977a.129.129,0,1,1-.129-.129.131.131,0,0,1,.129.129Zm.011,0a.138.138,0,0,0-.141-.135.134.134,0,0,0-.135.135.138.138,0,0,0,.135.14.143.143,0,0,0,.141-.14Z",
    transform: "translate(-256.013 -251.633)",
    fill: "#ffead8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12708",
    "data-name": "Group 12708",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38073",
    "data-name": "Path 38073",
    d: "M257.352,252.9a.135.135,0,1,1-.135-.135.134.134,0,0,1,.135.135Zm.011,0a.141.141,0,0,0-.146-.14.136.136,0,0,0-.141.14.141.141,0,0,0,.141.146.145.145,0,0,0,.146-.146Z",
    transform: "translate(-255.927 -251.552)",
    fill: "#ffead8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12709",
    "data-name": "Group 12709",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38075",
    "data-name": "Path 38075",
    d: "M257.276,252.81a.141.141,0,1,1-.141-.14.143.143,0,0,1,.141.14Zm.011,0a.15.15,0,0,0-.151-.146.145.145,0,0,0-.146.146.15.15,0,0,0,.146.151.155.155,0,0,0,.151-.151Z",
    transform: "translate(-255.846 -251.466)",
    fill: "#fee9d8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12710",
    "data-name": "Group 12710",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38077",
    "data-name": "Path 38077",
    d: "M257.2,252.723a.146.146,0,1,1-.146-.146.145.145,0,0,1,.146.146Zm.011,0a.152.152,0,0,0-.157-.151.148.148,0,0,0-.151.151.152.152,0,0,0,.151.156.157.157,0,0,0,.157-.156Z",
    transform: "translate(-255.76 -251.379)",
    fill: "#fde8d7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12711",
    "data-name": "Group 12711",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38079",
    "data-name": "Path 38079",
    d: "M257.114,252.642a.148.148,0,0,1-.151.151.151.151,0,0,1-.151-.151.155.155,0,0,1,.151-.151.151.151,0,0,1,.151.151Zm.011,0a.161.161,0,0,0-.162-.156.157.157,0,0,0-.157.156.161.161,0,0,0,.157.162.166.166,0,0,0,.162-.162Z",
    transform: "translate(-255.673 -251.298)",
    fill: "#fde8d7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12712",
    "data-name": "Group 12712",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38081",
    "data-name": "Path 38081",
    d: "M257.038,252.555a.157.157,0,1,1-.157-.156.157.157,0,0,1,.157.156Zm.011,0a.164.164,0,0,0-.167-.162.159.159,0,0,0-.162.162.163.163,0,0,0,.162.167.168.168,0,0,0,.167-.167Z",
    transform: "translate(-255.591 -251.211)",
    fill: "#fde9d6",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12713",
    "data-name": "Group 12713",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38083",
    "data-name": "Path 38083",
    d: "M256.961,252.468a.159.159,0,0,1-.162.162.162.162,0,0,1-.162-.162.166.166,0,0,1,.162-.162.162.162,0,0,1,.162.162Zm.011,0a.173.173,0,0,0-.173-.167.168.168,0,0,0-.167.167.173.173,0,0,0,.167.173.178.178,0,0,0,.173-.173Z",
    transform: "translate(-255.509 -251.125)",
    fill: "#fde7d6",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12714",
    "data-name": "Group 12714",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38085",
    "data-name": "Path 38085",
    d: "M256.874,252.388a.167.167,0,1,1-.167-.167.168.168,0,0,1,.167.167Zm.011,0a.175.175,0,0,0-.178-.173.171.171,0,0,0-.173.173.176.176,0,0,0,.173.178.18.18,0,0,0,.178-.178Z",
    transform: "translate(-255.416 -251.044)",
    fill: "#fde7d5",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12715",
    "data-name": "Group 12715",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38087",
    "data-name": "Path 38087",
    d: "M256.8,252.3a.173.173,0,1,1-.173-.173.171.171,0,0,1,.173.173Zm.01,0a.181.181,0,1,0-.183.183.181.181,0,0,0,.183-.183Z",
    transform: "translate(-255.336 -250.955)",
    fill: "#fde7d5",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12716",
    "data-name": "Group 12716",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38089",
    "data-name": "Path 38089",
    d: "M256.723,252.218a.178.178,0,1,1-.178-.178.18.18,0,0,1,.178.178Zm.011,0a.187.187,0,0,0-.189-.183.182.182,0,0,0-.183.183.186.186,0,0,0,.183.189.191.191,0,0,0,.189-.189Z",
    transform: "translate(-255.256 -250.874)",
    fill: "#fde6d4",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12717",
    "data-name": "Group 12717",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38091",
    "data-name": "Path 38091",
    d: "M256.642,252.132a.183.183,0,1,1-.183-.183.182.182,0,0,1,.183.183Zm.011,0a.192.192,0,1,0-.194.194.192.192,0,0,0,.194-.194Z",
    transform: "translate(-255.169 -250.788)",
    fill: "#fde6d4",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12718",
    "data-name": "Group 12718",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38093",
    "data-name": "Path 38093",
    d: "M256.561,252.045a.189.189,0,1,1-.189-.189.191.191,0,0,1,.189.189Zm.01,0a.2.2,0,0,0-.2-.194.193.193,0,0,0-.194.194.2.2,0,0,0,.194.2.2.2,0,0,0,.2-.2Z",
    transform: "translate(-255.082 -250.701)",
    fill: "#fde6d3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12719",
    "data-name": "Group 12719",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38095",
    "data-name": "Path 38095",
    d: "M256.485,251.958a.194.194,0,1,1-.194-.194.193.193,0,0,1,.194.194Zm.011,0a.2.2,0,0,0-.2-.2.2.2,0,0,0-.2.2.2.2,0,0,0,.2.205.205.205,0,0,0,.2-.205Z",
    transform: "translate(-255.001 -250.614)",
    fill: "#fee6d3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12720",
    "data-name": "Group 12720",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38097",
    "data-name": "Path 38097",
    d: "M256.4,251.877a.2.2,0,1,1-.2-.2.2.2,0,0,1,.2.2Zm.011,0a.21.21,0,0,0-.211-.205.205.205,0,0,0-.205.205.21.21,0,0,0,.205.21.215.215,0,0,0,.211-.21Z",
    transform: "translate(-254.912 -250.533)",
    fill: "#fde5d2",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12721",
    "data-name": "Group 12721",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38099",
    "data-name": "Path 38099",
    d: "M256.322,251.791a.205.205,0,1,1-.2-.205.205.205,0,0,1,.2.205Zm.011,0a.212.212,0,0,0-.216-.211.208.208,0,0,0-.211.211.212.212,0,0,0,.211.216.216.216,0,0,0,.216-.216Z",
    transform: "translate(-254.827 -250.447)",
    fill: "#fde5d1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12722",
    "data-name": "Group 12722",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38101",
    "data-name": "Path 38101",
    d: "M256.246,251.7a.207.207,0,0,1-.211.21.211.211,0,0,1-.211-.21.215.215,0,0,1,.211-.211.211.211,0,0,1,.211.211Zm.011,0a.221.221,0,0,0-.221-.216.217.217,0,0,0-.216.216.221.221,0,0,0,.216.221.226.226,0,0,0,.221-.221Z",
    transform: "translate(-254.746 -250.36)",
    fill: "#fee5d1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12723",
    "data-name": "Group 12723",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38103",
    "data-name": "Path 38103",
    d: "M256.165,251.622a.216.216,0,1,1-.216-.216.216.216,0,0,1,.216.216Zm.011,0a.223.223,0,0,0-.227-.221.219.219,0,0,0-.221.221.224.224,0,0,0,.221.227.228.228,0,0,0,.227-.227Z",
    transform: "translate(-254.66 -250.278)",
    fill: "#fde4d0",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12724",
    "data-name": "Group 12724",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38105",
    "data-name": "Path 38105",
    d: "M256.083,251.536a.221.221,0,1,1-.221-.221.219.219,0,0,1,.221.221Zm.011,0a.229.229,0,1,0-.232.232.229.229,0,0,0,.232-.232Z",
    transform: "translate(-254.572 -250.192)",
    fill: "#fde4d0",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12725",
    "data-name": "Group 12725",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38107",
    "data-name": "Path 38107",
    d: "M256.008,251.448a.227.227,0,1,1-.227-.227.228.228,0,0,1,.227.227Zm.011,0a.235.235,0,0,0-.237-.232.231.231,0,0,0-.232.232.235.235,0,0,0,.232.237.24.24,0,0,0,.237-.237Z",
    transform: "translate(-254.491 -250.104)",
    fill: "#fee4cf",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12726",
    "data-name": "Group 12726",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38109",
    "data-name": "Path 38109",
    d: "M255.93,251.367a.232.232,0,1,1-.232-.232.23.23,0,0,1,.232.232Zm.011,0a.24.24,0,1,0-.243.243.241.241,0,0,0,.243-.243Z",
    transform: "translate(-254.409 -250.023)",
    fill: "#fee4cf",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12727",
    "data-name": "Group 12727",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38111",
    "data-name": "Path 38111",
    d: "M255.844,251.28a.237.237,0,1,1-.237-.238.24.24,0,0,1,.237.238Zm.011,0a.247.247,0,0,0-.248-.243.242.242,0,0,0-.243.243.246.246,0,0,0,.243.248.251.251,0,0,0,.248-.248Z",
    transform: "translate(-254.316 -249.936)",
    fill: "#fee4cf",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12728",
    "data-name": "Group 12728",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38113",
    "data-name": "Path 38113",
    d: "M255.769,251.2a.243.243,0,1,1-.243-.243.242.242,0,0,1,.243.243Zm.011,0a.249.249,0,0,0-.254-.248.244.244,0,0,0-.248.248.249.249,0,0,0,.248.254.253.253,0,0,0,.254-.254Z",
    transform: "translate(-254.237 -249.856)",
    fill: "#fee4cf",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12729",
    "data-name": "Group 12729",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38115",
    "data-name": "Path 38115",
    d: "M255.693,251.113a.248.248,0,1,1-.248-.248.251.251,0,0,1,.248.248Zm.011,0a.258.258,0,0,0-.259-.254.253.253,0,0,0-.253.254.258.258,0,0,0,.253.259.263.263,0,0,0,.259-.259Z",
    transform: "translate(-254.155 -249.769)",
    fill: "#fee3cd",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12730",
    "data-name": "Group 12730",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38117",
    "data-name": "Path 38117",
    d: "M255.612,251.025a.254.254,0,1,1-.254-.254.253.253,0,0,1,.254.254Zm.011,0a.26.26,0,0,0-.264-.259.256.256,0,0,0-.259.259.26.26,0,0,0,.259.264.265.265,0,0,0,.264-.264Z",
    transform: "translate(-254.068 -249.681)",
    fill: "#fee3cd",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12731",
    "data-name": "Group 12731",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38119",
    "data-name": "Path 38119",
    d: "M255.531,250.944a.256.256,0,0,1-.259.259.259.259,0,0,1-.259-.259.263.263,0,0,1,.259-.259.26.26,0,0,1,.259.259Zm.01,0a.269.269,0,0,0-.27-.264.265.265,0,0,0-.264.264.27.27,0,0,0,.264.27.274.274,0,0,0,.27-.27Z",
    transform: "translate(-253.982 -249.601)",
    fill: "#fee2cc",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12732",
    "data-name": "Group 12732",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38121",
    "data-name": "Path 38121",
    d: "M255.453,250.858a.264.264,0,1,1-.264-.264.265.265,0,0,1,.264.264Zm.011,0a.272.272,0,0,0-.276-.27.267.267,0,0,0-.27.27.271.271,0,0,0,.27.275.276.276,0,0,0,.276-.275Z",
    transform: "translate(-253.899 -249.514)",
    fill: "#fee2cb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12733",
    "data-name": "Group 12733",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38123",
    "data-name": "Path 38123",
    d: "M255.366,250.776a.267.267,0,0,1-.27.27.27.27,0,0,1-.27-.27.274.274,0,0,1,.27-.27.27.27,0,0,1,.27.27Zm.011,0a.281.281,0,0,0-.281-.275.276.276,0,0,0-.276.275.281.281,0,0,0,.276.281.286.286,0,0,0,.281-.281Z",
    transform: "translate(-253.807 -249.432)",
    fill: "#fce2cc",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12734",
    "data-name": "Group 12734",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38125",
    "data-name": "Path 38125",
    d: "M255.292,250.69a.276.276,0,1,1-.275-.275.276.276,0,0,1,.275.275Zm.01,0a.283.283,0,0,0-.286-.281.279.279,0,0,0-.281.281.283.283,0,0,0,.281.286.288.288,0,0,0,.286-.286Z",
    transform: "translate(-253.727 -249.346)",
    fill: "#fde2ca",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12735",
    "data-name": "Group 12735",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38127",
    "data-name": "Path 38127",
    d: "M255.21,250.6a.281.281,0,1,1-.281-.281.279.279,0,0,1,.281.281Zm.011,0a.289.289,0,1,0-.291.291.289.289,0,0,0,.291-.291Z",
    transform: "translate(-253.639 -249.259)",
    fill: "#fce1cb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12736",
    "data-name": "Group 12736",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38129",
    "data-name": "Path 38129",
    d: "M255.128,250.521a.286.286,0,1,1-.286-.286.288.288,0,0,1,.286.286Zm.011,0a.3.3,0,0,0-.3-.291.29.29,0,0,0-.292.291.3.3,0,0,0,.292.3.3.3,0,0,0,.3-.3Z",
    transform: "translate(-253.552 -249.177)",
    fill: "#fde1c9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12737",
    "data-name": "Group 12737",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38131",
    "data-name": "Path 38131",
    d: "M255.052,250.434a.292.292,0,1,1-.291-.291.29.29,0,0,1,.291.291Zm.011,0a.3.3,0,0,0-.3-.3.293.293,0,0,0-.3.3.3.3,0,0,0,.3.3.3.3,0,0,0,.3-.3Z",
    transform: "translate(-253.471 -249.09)",
    fill: "#fde1c9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12738",
    "data-name": "Group 12738",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38133",
    "data-name": "Path 38133",
    d: "M254.977,250.347a.3.3,0,1,1-.3-.3.3.3,0,0,1,.3.3Zm.011,0a.306.306,0,0,0-.308-.3.3.3,0,0,0-.3.3.306.306,0,0,0,.3.308.311.311,0,0,0,.308-.308Z",
    transform: "translate(-253.39 -249.004)",
    fill: "#fce0c8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12739",
    "data-name": "Group 12739",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38135",
    "data-name": "Path 38135",
    d: "M254.889,250.267a.3.3,0,1,1-.3-.3.3.3,0,0,1,.3.3Zm.011,0a.309.309,0,0,0-.313-.308.308.308,0,1,0,0,.615.309.309,0,0,0,.313-.308Z",
    transform: "translate(-253.297 -248.923)",
    fill: "#fce0c7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12740",
    "data-name": "Group 12740",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38137",
    "data-name": "Path 38137",
    d: "M254.814,250.18a.3.3,0,0,1-.307.308.308.308,0,0,1-.308-.308.311.311,0,0,1,.308-.308.307.307,0,0,1,.307.308Zm.011,0a.318.318,0,0,0-.318-.313.313.313,0,1,0,0,.626.318.318,0,0,0,.318-.313Z",
    transform: "translate(-253.216 -248.836)",
    fill: "#fce0c7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12741",
    "data-name": "Group 12741",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38139",
    "data-name": "Path 38139",
    d: "M254.738,250.093a.313.313,0,1,1-.313-.313.313.313,0,0,1,.313.313Zm.011,0a.32.32,0,0,0-.324-.319.318.318,0,0,0,0,.637.32.32,0,0,0,.324-.318Z",
    transform: "translate(-253.136 -248.749)",
    fill: "#fcdfc6",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12742",
    "data-name": "Group 12742",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38141",
    "data-name": "Path 38141",
    d: "M254.656,250.012a.315.315,0,0,1-.318.318.319.319,0,0,1-.318-.318.323.323,0,0,1,.318-.319.319.319,0,0,1,.318.319Zm.005,0a.324.324,0,1,0-.324.324.325.325,0,0,0,.324-.324Z",
    transform: "translate(-253.048 -248.668)",
    fill: "#fcdfc6",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12743",
    "data-name": "Group 12743",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38143",
    "data-name": "Path 38143",
    d: "M254.575,249.924a.324.324,0,1,1-.324-.324.325.325,0,0,1,.324.324Zm.005,0a.329.329,0,1,0-.329.329.327.327,0,0,0,.329-.329Z",
    transform: "translate(-252.962 -248.58)",
    fill: "#fcdfc5",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12744",
    "data-name": "Group 12744",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38145",
    "data-name": "Path 38145",
    d: "M254.5,249.844a.329.329,0,1,1-.329-.329.327.327,0,0,1,.329.329Zm.005,0a.333.333,0,0,0-.335-.335.336.336,0,0,0-.335.335.333.333,0,0,0,.335.334.329.329,0,0,0,.335-.334Z",
    transform: "translate(-252.881 -248.5)",
    fill: "#fcdec5",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12745",
    "data-name": "Group 12745",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38147",
    "data-name": "Path 38147",
    d: "M254.417,249.757a.335.335,0,1,1-.335-.335.336.336,0,0,1,.335.335Zm.005,0a.34.34,0,1,0-.34.34.339.339,0,0,0,.34-.34Z",
    transform: "translate(-252.792 -248.413)",
    fill: "#fcdec4",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12746",
    "data-name": "Group 12746",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38149",
    "data-name": "Path 38149",
    d: "M254.337,249.671a.34.34,0,1,1-.34-.34.339.339,0,0,1,.34.34Zm.006,0a.345.345,0,0,0-.345-.346.348.348,0,0,0-.346.346.344.344,0,0,0,.346.345.341.341,0,0,0,.345-.345Z",
    transform: "translate(-252.707 -248.327)",
    fill: "#fcdec4",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12747",
    "data-name": "Group 12747",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38151",
    "data-name": "Path 38151",
    d: "M254.261,249.59a.346.346,0,1,1-.345-.346.348.348,0,0,1,.345.346Zm.005,0a.351.351,0,1,0-.351.351.35.35,0,0,0,.351-.351Z",
    transform: "translate(-252.626 -248.246)",
    fill: "#fcdcc3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12748",
    "data-name": "Group 12748",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38153",
    "data-name": "Path 38153",
    d: "M254.179,249.5a.351.351,0,1,1-.351-.351.35.35,0,0,1,.351.351Zm.006,0a.356.356,0,1,0-.356.356.353.353,0,0,0,.356-.356Z",
    transform: "translate(-252.539 -248.158)",
    fill: "#fcdcc2",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12749",
    "data-name": "Group 12749",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38155",
    "data-name": "Path 38155",
    d: "M254.1,249.42a.356.356,0,1,1-.356-.356.359.359,0,0,1,.356.356Zm.005,0a.362.362,0,1,0-.362.361.362.362,0,0,0,.362-.361Z",
    transform: "translate(-252.451 -248.077)",
    fill: "#fcdcc2",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12750",
    "data-name": "Group 12750",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38157",
    "data-name": "Path 38157",
    d: "M254.022,249.333a.362.362,0,1,1-.362-.361.362.362,0,0,1,.362.361Zm.005,0a.367.367,0,1,0-.367.367.364.364,0,0,0,.367-.367Z",
    transform: "translate(-252.37 -247.989)",
    fill: "#fcdcc1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12751",
    "data-name": "Group 12751",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38159",
    "data-name": "Path 38159",
    d: "M253.939,249.247a.367.367,0,1,1-.734,0,.367.367,0,1,1,.734,0Zm.006,0a.373.373,0,1,0-.373.372.373.373,0,0,0,.373-.372Z",
    transform: "translate(-252.283 -247.903)",
    fill: "#fcdcc1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12752",
    "data-name": "Group 12752",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38161",
    "data-name": "Path 38161",
    d: "M253.86,249.166a.373.373,0,1,1-.373-.373.373.373,0,0,1,.373.373Zm.005,0a.378.378,0,1,0-.378.378.375.375,0,0,0,.378-.378Z",
    transform: "translate(-252.197 -247.822)",
    fill: "#fcdbc1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12753",
    "data-name": "Group 12753",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38163",
    "data-name": "Path 38163",
    d: "M253.784,249.079a.378.378,0,1,1-.378-.378.376.376,0,0,1,.378.378Zm.005,0a.383.383,0,1,0-.383.383.381.381,0,0,0,.383-.383Z",
    transform: "translate(-252.117 -247.735)",
    fill: "#fcdbc0",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12754",
    "data-name": "Group 12754",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38165",
    "data-name": "Path 38165",
    d: "M253.708,248.993a.383.383,0,1,1-.383-.383.385.385,0,0,1,.383.383Zm.006,0a.389.389,0,1,0-.389.388.387.387,0,0,0,.389-.388Z",
    transform: "translate(-252.036 -247.649)",
    fill: "#fcdbc0",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12755",
    "data-name": "Group 12755",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38167",
    "data-name": "Path 38167",
    d: "M253.62,248.911a.388.388,0,1,1-.389-.389.387.387,0,0,1,.389.389Zm.006,0a.394.394,0,1,0-.394.394.393.393,0,0,0,.394-.394Z",
    transform: "translate(-251.942 -247.567)",
    fill: "#fcdbbf",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12756",
    "data-name": "Group 12756",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38169",
    "data-name": "Path 38169",
    d: "M253.545,248.823a.394.394,0,1,1-.394-.394.4.4,0,0,1,.394.394Zm.005,0a.4.4,0,1,0-.4.4.4.4,0,0,0,.4-.4Z",
    transform: "translate(-251.861 -247.48)",
    fill: "#fcd9be",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12757",
    "data-name": "Group 12757",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38171",
    "data-name": "Path 38171",
    d: "M253.469,248.737a.4.4,0,1,1-.4-.4.4.4,0,0,1,.4.4Zm.005,0a.4.4,0,1,0-.4.4.4.4,0,0,0,.4-.4Z",
    transform: "translate(-251.78 -247.393)",
    fill: "#fcdabe",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12758",
    "data-name": "Group 12758",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38173",
    "data-name": "Path 38173",
    d: "M253.387,248.65a.4.4,0,1,1-.4-.4.408.408,0,0,1,.4.4Zm.006,0a.41.41,0,1,0-.41.41.41.41,0,0,0,.41-.41Z",
    transform: "translate(-251.692 -247.307)",
    fill: "#fcd8bc",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12759",
    "data-name": "Group 12759",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38175",
    "data-name": "Path 38175",
    d: "M253.307,248.57a.41.41,0,1,1-.41-.41.41.41,0,0,1,.41.41Zm.005,0a.416.416,0,1,0-.416.416.412.412,0,0,0,.416-.416Z",
    transform: "translate(-251.607 -247.226)",
    fill: "#fcd8bb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12760",
    "data-name": "Group 12760",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38177",
    "data-name": "Path 38177",
    d: "M253.23,248.482a.416.416,0,0,1-.831,0,.416.416,0,0,1,.831,0Zm.005,0a.421.421,0,1,0-.421.421.421.421,0,0,0,.421-.421Z",
    transform: "translate(-251.525 -247.138)",
    fill: "#fcd8bb",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12761",
    "data-name": "Group 12761",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38179",
    "data-name": "Path 38179",
    d: "M253.149,248.4a.421.421,0,1,1-.421-.421.422.422,0,0,1,.421.421Zm.006,0a.426.426,0,1,0-.426.426.424.424,0,0,0,.426-.426Z",
    transform: "translate(-251.439 -247.057)",
    fill: "#fcd7ba",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12762",
    "data-name": "Group 12762",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38181",
    "data-name": "Path 38181",
    d: "M253.067,248.314a.426.426,0,1,1-.853,0,.426.426,0,1,1,.853,0Zm.006,0a.432.432,0,1,0-.432.432.433.433,0,0,0,.432-.432Z",
    transform: "translate(-251.351 -246.97)",
    fill: "#fcd7b9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12763",
    "data-name": "Group 12763",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38183",
    "data-name": "Path 38183",
    d: "M252.991,248.226a.432.432,0,1,1-.432-.432.433.433,0,0,1,.432.432Zm.005,0a.437.437,0,1,0-.437.437.435.435,0,0,0,.437-.437Z",
    transform: "translate(-251.269 -246.883)",
    fill: "#fed7b8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12764",
    "data-name": "Group 12764",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38185",
    "data-name": "Path 38185",
    d: "M252.909,248.146a.437.437,0,1,1-.437-.437.435.435,0,0,1,.437.437Zm.006,0a.443.443,0,1,0-.443.443.441.441,0,0,0,.443-.443Z",
    transform: "translate(-251.182 -246.802)",
    fill: "#fed7b8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12765",
    "data-name": "Group 12765",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38187",
    "data-name": "Path 38187",
    d: "M252.829,248.06a.443.443,0,1,1-.443-.443.444.444,0,0,1,.443.443Zm.006,0a.448.448,0,1,0-.448.448.447.447,0,0,0,.448-.448Z",
    transform: "translate(-251.096 -246.716)",
    fill: "#fed7b7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12766",
    "data-name": "Group 12766",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38189",
    "data-name": "Path 38189",
    d: "M252.753,247.973a.448.448,0,1,1-.448-.448.447.447,0,0,1,.448.448Zm.005,0a.453.453,0,1,0-.453.453.449.449,0,0,0,.453-.453Z",
    transform: "translate(-251.016 -246.629)",
    fill: "#fed6b7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12767",
    "data-name": "Group 12767",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38191",
    "data-name": "Path 38191",
    d: "M252.678,247.892a.453.453,0,1,1-.453-.454.456.456,0,0,1,.453.454Zm.006,0a.459.459,0,1,0-.459.459.458.458,0,0,0,.459-.459Z",
    transform: "translate(-250.935 -246.548)",
    fill: "#fed6b5",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12768",
    "data-name": "Group 12768",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38193",
    "data-name": "Path 38193",
    d: "M252.589,247.8a.459.459,0,1,1-.459-.459.458.458,0,0,1,.459.459Zm.005,0a.464.464,0,1,0-.464.464.461.461,0,0,0,.464-.464Z",
    transform: "translate(-250.841 -246.46)",
    fill: "#fcd5b6",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12769",
    "data-name": "Group 12769",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38195",
    "data-name": "Path 38195",
    d: "M252.514,247.723a.464.464,0,1,1-.929,0,.464.464,0,1,1,.929,0Zm.005,0a.47.47,0,1,0-.47.469.47.47,0,0,0,.47-.469Z",
    transform: "translate(-250.76 -246.38)",
    fill: "#fcd5b4",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12770",
    "data-name": "Group 12770",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38197",
    "data-name": "Path 38197",
    d: "M252.437,247.636a.47.47,0,1,1-.47-.469.47.47,0,0,1,.47.469Zm.005,0a.475.475,0,1,0-.475.475.472.472,0,0,0,.475-.475Z",
    transform: "translate(-250.678 -246.292)",
    fill: "#fcd4b3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12771",
    "data-name": "Group 12771",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38199",
    "data-name": "Path 38199",
    d: "M252.357,247.55a.475.475,0,1,1-.95,0,.475.475,0,1,1,.95,0Zm.006,0a.48.48,0,1,0-.48.48.482.482,0,0,0,.48-.48Z",
    transform: "translate(-250.592 -246.206)",
    fill: "#fcd4b3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12772",
    "data-name": "Group 12772",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38201",
    "data-name": "Path 38201",
    d: "M252.275,247.469a.48.48,0,1,1-.48-.481.481.481,0,0,1,.48.481Zm.005,0a.486.486,0,1,0-.486.486.484.484,0,0,0,.486-.486Z",
    transform: "translate(-250.505 -246.125)",
    fill: "#fcd4b3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12773",
    "data-name": "Group 12773",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38203",
    "data-name": "Path 38203",
    d: "M252.194,247.381a.486.486,0,1,1-.486-.486.484.484,0,0,1,.486.486Zm.005,0a.491.491,0,1,0-.491.491.489.489,0,0,0,.491-.491Z",
    transform: "translate(-250.419 -246.037)",
    fill: "#fcd3b2",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12774",
    "data-name": "Group 12774",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38205",
    "data-name": "Path 38205",
    d: "M252.112,247.3a.491.491,0,1,1-.491-.491.493.493,0,0,1,.491.491Zm.006,0a.5.5,0,1,0-.5.5.495.495,0,0,0,.5-.5Z",
    transform: "translate(-250.331 -245.957)",
    fill: "#fcd3b0",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12775",
    "data-name": "Group 12775",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38207",
    "data-name": "Path 38207",
    d: "M252.036,247.214a.5.5,0,1,1-.5-.5.495.495,0,0,1,.5.5Zm.005,0a.5.5,0,1,0-.5.5.5.5,0,0,0,.5-.5Z",
    transform: "translate(-250.25 -245.87)",
    fill: "#fcd2b0",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12776",
    "data-name": "Group 12776",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38209",
    "data-name": "Path 38209",
    d: "M251.954,247.126a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5Zm.005,0a.507.507,0,1,0-.507.507.507.507,0,0,0,.507-.507Z",
    transform: "translate(-250.163 -245.783)",
    fill: "#fcd2b0",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12777",
    "data-name": "Group 12777",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38211",
    "data-name": "Path 38211",
    d: "M251.874,247.046a.507.507,0,1,1-.507-.508.507.507,0,0,1,.507.508Zm.006,0a.513.513,0,1,0-.513.513.509.509,0,0,0,.513-.513Z",
    transform: "translate(-250.077 -245.702)",
    fill: "#fcd2ae",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12778",
    "data-name": "Group 12778",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38213",
    "data-name": "Path 38213",
    d: "M251.8,246.959a.513.513,0,1,1-.513-.513.516.516,0,0,1,.513.513Zm.006,0a.518.518,0,1,0-.518.518.518.518,0,0,0,.518-.518Z",
    transform: "translate(-249.995 -245.615)",
    fill: "#fcd2ae",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12779",
    "data-name": "Group 12779",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38215",
    "data-name": "Path 38215",
    d: "M251.722,246.872a.518.518,0,1,1-.518-.518.518.518,0,0,1,.518.518Zm.005,0a.523.523,0,1,0-.523.523.521.521,0,0,0,.523-.523Z",
    transform: "translate(-249.915 -245.528)",
    fill: "#fcd2ad",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12780",
    "data-name": "Group 12780",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38217",
    "data-name": "Path 38217",
    d: "M251.635,246.791a.523.523,0,1,1-1.047,0,.523.523,0,1,1,1.047,0Zm.006,0a.529.529,0,1,0-.529.529.53.53,0,0,0,.529-.529Z",
    transform: "translate(-249.822 -245.447)",
    fill: "#fcd0ad",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12781",
    "data-name": "Group 12781",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38219",
    "data-name": "Path 38219",
    d: "M251.56,246.7a.529.529,0,1,1-.529-.529.53.53,0,0,1,.529.529Zm.005,0a.534.534,0,1,0-.534.534.532.532,0,0,0,.534-.534Z",
    transform: "translate(-249.741 -245.36)",
    fill: "#fcd0ab",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12782",
    "data-name": "Group 12782",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38221",
    "data-name": "Path 38221",
    d: "M251.483,246.623a.534.534,0,0,1-1.069,0,.534.534,0,0,1,1.069,0Zm.005,0a.54.54,0,1,0-.54.54.538.538,0,0,0,.54-.54Z",
    transform: "translate(-249.659 -245.279)",
    fill: "#fcd1ab",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12783",
    "data-name": "Group 12783",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38223",
    "data-name": "Path 38223",
    d: "M251.4,246.536a.54.54,0,1,1-.54-.54.541.541,0,0,1,.54.54Zm.006,0a.545.545,0,1,0-.545.545.544.544,0,0,0,.545-.545Z",
    transform: "translate(-249.573 -245.192)",
    fill: "#fccfaa",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12784",
    "data-name": "Group 12784",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38225",
    "data-name": "Path 38225",
    d: "M251.321,246.449a.545.545,0,1,1-.545-.545.544.544,0,0,1,.545.545Zm.005,0a.551.551,0,1,0-.551.551.55.55,0,0,0,.551-.551Z",
    transform: "translate(-249.486 -245.105)",
    fill: "#fccfaa",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12785",
    "data-name": "Group 12785",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38227",
    "data-name": "Path 38227",
    d: "M251.244,246.368a.551.551,0,1,1-.551-.551.553.553,0,0,1,.551.551Zm.005,0a.556.556,0,1,0-.556.556.555.555,0,0,0,.556-.556Z",
    transform: "translate(-249.404 -245.024)",
    fill: "#fbcea9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12786",
    "data-name": "Group 12786",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38229",
    "data-name": "Path 38229",
    d: "M251.163,246.28a.556.556,0,1,1-.556-.556.555.555,0,0,1,.556.556Zm.006,0a.561.561,0,1,0-.561.561.557.557,0,0,0,.561-.561Z",
    transform: "translate(-249.318 -244.936)",
    fill: "#fccea7",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12787",
    "data-name": "Group 12787",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38231",
    "data-name": "Path 38231",
    d: "M251.082,246.194a.561.561,0,1,1-.561-.561.564.564,0,0,1,.561.561Zm.006,0a.567.567,0,1,0-.567.567.567.567,0,0,0,.567-.567Z",
    transform: "translate(-249.231 -244.85)",
    fill: "#fbcea6",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12788",
    "data-name": "Group 12788",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38233",
    "data-name": "Path 38233",
    d: "M251,246.113a.567.567,0,1,1-.567-.567.566.566,0,0,1,.567.567Zm.005,0a.572.572,0,1,0-.572.572.569.569,0,0,0,.572-.572Z",
    transform: "translate(-249.148 -244.769)",
    fill: "#fbcea6",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12789",
    "data-name": "Group 12789",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38235",
    "data-name": "Path 38235",
    d: "M250.925,246.027a.572.572,0,1,1-1.144,0,.572.572,0,1,1,1.144,0Zm.006,0a.577.577,0,1,0-.577.578.578.578,0,0,0,.577-.578Z",
    transform: "translate(-249.064 -244.683)",
    fill: "#fbcda6",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12790",
    "data-name": "Group 12790",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38237",
    "data-name": "Path 38237",
    d: "M250.844,245.946a.577.577,0,1,1-.577-.578.578.578,0,0,1,.577.578Zm.006,0a.583.583,0,1,0-.583.583.58.58,0,0,0,.583-.583Z",
    transform: "translate(-248.976 -244.602)",
    fill: "#fdcda5",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12791",
    "data-name": "Group 12791",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38239",
    "data-name": "Path 38239",
    d: "M250.767,245.858a.583.583,0,0,1-1.166,0,.583.583,0,0,1,1.166,0Zm.005,0a.588.588,0,1,0-.588.588.59.59,0,0,0,.588-.588Z",
    transform: "translate(-248.895 -244.514)",
    fill: "#fdcda3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12792",
    "data-name": "Group 12792",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38241",
    "data-name": "Path 38241",
    d: "M250.692,245.771a.588.588,0,1,1-.588-.588.59.59,0,0,1,.588.588Zm.006,0a.594.594,0,1,0-.594.594.592.592,0,0,0,.594-.594Z",
    transform: "translate(-248.814 -244.427)",
    fill: "#fdcca4",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12793",
    "data-name": "Group 12793",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38243",
    "data-name": "Path 38243",
    d: "M250.6,245.684a.594.594,0,1,1-.594-.594.592.592,0,0,1,.594.594Zm.006,0a.6.6,0,1,0-.6.6.6.6,0,0,0,.6-.6Z",
    transform: "translate(-248.721 -244.34)",
    fill: "#fdcca3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12794",
    "data-name": "Group 12794",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38245",
    "data-name": "Path 38245",
    d: "M250.528,245.6a.6.6,0,1,1-.6-.6.6.6,0,0,1,.6.6Zm.005,0a.6.6,0,1,0-.6.6.6.6,0,0,0,.6-.6Z",
    transform: "translate(-248.639 -244.26)",
    fill: "#fdcca2",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12795",
    "data-name": "Group 12795",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38247",
    "data-name": "Path 38247",
    d: "M250.453,245.517a.6.6,0,1,1-.6-.6.6.6,0,0,1,.6.6Zm.006,0a.61.61,0,1,0-.61.61.609.609,0,0,0,.61-.61Z",
    transform: "translate(-248.559 -244.173)",
    fill: "#fbcba1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12796",
    "data-name": "Group 12796",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38249",
    "data-name": "Path 38249",
    d: "M250.372,245.43a.61.61,0,1,1-.61-.61.613.613,0,0,1,.61.61Zm.006,0a.615.615,0,1,0-.615.615.615.615,0,0,0,.615-.615Z",
    transform: "translate(-248.472 -244.086)",
    fill: "#fbcba1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12797",
    "data-name": "Group 12797",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38251",
    "data-name": "Path 38251",
    d: "M250.29,245.349a.615.615,0,1,1-.615-.616.615.615,0,0,1,.615.616Zm.005,0a.621.621,0,1,0-.621.621.617.617,0,0,0,.621-.621Z",
    transform: "translate(-248.385 -244.005)",
    fill: "#fbcaa0",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12798",
    "data-name": "Group 12798",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38253",
    "data-name": "Path 38253",
    d: "M250.215,245.261a.621.621,0,0,1-1.241,0,.621.621,0,0,1,1.241,0Zm.005,0a.626.626,0,1,0-.626.626.626.626,0,0,0,.626-.626Z",
    transform: "translate(-248.304 -243.917)",
    fill: "#fbca9f",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12799",
    "data-name": "Group 12799",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38255",
    "data-name": "Path 38255",
    d: "M250.132,245.18a.626.626,0,1,1-.626-.626.627.627,0,0,1,.626.626Zm.006,0a.632.632,0,1,0-.632.631.629.629,0,0,0,.632-.631Z",
    transform: "translate(-248.217 -243.837)",
    fill: "#fbc99e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12800",
    "data-name": "Group 12800",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38257",
    "data-name": "Path 38257",
    d: "M250.051,245.093a.632.632,0,0,1-1.263,0,.632.632,0,0,1,1.263,0Zm.005,0a.637.637,0,1,0-.637.637.638.638,0,0,0,.637-.637Z",
    transform: "translate(-248.129 -243.749)",
    fill: "#fbc99e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12801",
    "data-name": "Group 12801",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38259",
    "data-name": "Path 38259",
    d: "M249.974,245.007a.637.637,0,1,1-.637-.637.638.638,0,0,1,.637.637Zm.005,0a.642.642,0,1,0-.642.642.64.64,0,0,0,.642-.642Z",
    transform: "translate(-248.048 -243.664)",
    fill: "#fbc99d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12802",
    "data-name": "Group 12802",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38261",
    "data-name": "Path 38261",
    d: "M249.895,244.926a.642.642,0,1,1-.642-.642.64.64,0,0,1,.642.642Zm.006,0a.648.648,0,1,0-.648.648.646.646,0,0,0,.648-.648Z",
    transform: "translate(-247.963 -243.582)",
    fill: "#fbc89c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12803",
    "data-name": "Group 12803",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38263",
    "data-name": "Path 38263",
    d: "M249.813,244.839a.648.648,0,1,1-.648-.648.649.649,0,0,1,.648.648Zm.006,0a.653.653,0,1,0-.653.653.652.652,0,0,0,.653-.653Z",
    transform: "translate(-247.875 -243.495)",
    fill: "#fbc89b",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12804",
    "data-name": "Group 12804",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38265",
    "data-name": "Path 38265",
    d: "M249.737,244.752a.653.653,0,1,1-.653-.653.652.652,0,0,1,.653.653Zm.005,0a.658.658,0,1,0-.658.658.658.658,0,0,0,.658-.658Z",
    transform: "translate(-247.795 -243.408)",
    fill: "#fbc79b",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12805",
    "data-name": "Group 12805",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38267",
    "data-name": "Path 38267",
    d: "M249.655,244.671a.658.658,0,1,1-.658-.659.661.661,0,0,1,.658.659Zm.006,0a.664.664,0,1,0-.664.664.663.663,0,0,0,.664-.664Z",
    transform: "translate(-247.707 -243.327)",
    fill: "#fbc79a",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12806",
    "data-name": "Group 12806",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38269",
    "data-name": "Path 38269",
    d: "M249.572,244.583a.664.664,0,1,1-.664-.664.663.663,0,0,1,.664.664Zm.005,0a.669.669,0,1,0-.669.669.666.666,0,0,0,.669-.669Z",
    transform: "translate(-247.619 -243.24)",
    fill: "#fbc798",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12807",
    "data-name": "Group 12807",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38271",
    "data-name": "Path 38271",
    d: "M249.5,244.5a.669.669,0,1,1-.669-.669.673.673,0,0,1,.669.669Zm.005,0a.675.675,0,1,0-.675.675.675.675,0,0,0,.675-.675Z",
    transform: "translate(-247.538 -243.153)",
    fill: "#fbc698",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12808",
    "data-name": "Group 12808",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38273",
    "data-name": "Path 38273",
    d: "M249.423,244.416a.675.675,0,1,1-.675-.675.675.675,0,0,1,.675.675Zm.006,0a.68.68,0,1,0-.68.68.677.677,0,0,0,.68-.68Z",
    transform: "translate(-247.459 -243.072)",
    fill: "#fbc698",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12809",
    "data-name": "Group 12809",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38275",
    "data-name": "Path 38275",
    d: "M249.336,244.329a.68.68,0,1,1-.68-.68.677.677,0,0,1,.68.68Zm.006,0a.686.686,0,1,0-.686.686.687.687,0,0,0,.686-.686Z",
    transform: "translate(-247.366 -242.985)",
    fill: "#fcc597",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12810",
    "data-name": "Group 12810",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38277",
    "data-name": "Path 38277",
    d: "M249.26,244.248a.686.686,0,1,1-.686-.686.687.687,0,0,1,.686.686Zm.005,0a.691.691,0,1,0-.691.691.689.689,0,0,0,.691-.691Z",
    transform: "translate(-247.285 -242.904)",
    fill: "#fbc596",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12811",
    "data-name": "Group 12811",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38279",
    "data-name": "Path 38279",
    d: "M249.178,244.161a.691.691,0,1,1-.691-.691.689.689,0,0,1,.691.691Zm.005,0a.7.7,0,1,0-.7.7.694.694,0,0,0,.7-.7Z",
    transform: "translate(-247.198 -242.817)",
    fill: "#fcc495",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12812",
    "data-name": "Group 12812",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38281",
    "data-name": "Path 38281",
    d: "M249.095,244.074a.7.7,0,1,1-.7-.7.7.7,0,0,1,.7.7Zm.006,0a.7.7,0,1,0-.7.7.7.7,0,0,0,.7-.7Z",
    transform: "translate(-247.109 -242.73)",
    fill: "#fcc494",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12813",
    "data-name": "Group 12813",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38283",
    "data-name": "Path 38283",
    d: "M249.02,243.992a.7.7,0,1,1-.7-.7.7.7,0,0,1,.7.7Zm.005,0a.707.707,0,1,0-.707.707.706.706,0,0,0,.707-.707Z",
    transform: "translate(-247.028 -242.648)",
    fill: "#fcc393",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12814",
    "data-name": "Group 12814",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38285",
    "data-name": "Path 38285",
    d: "M248.939,243.906a.707.707,0,1,1-.707-.707.71.71,0,0,1,.707.707Zm.005,0a.712.712,0,1,0-.712.712.711.711,0,0,0,.712-.712Z",
    transform: "translate(-246.943 -242.563)",
    fill: "#fcc393",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12815",
    "data-name": "Group 12815",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38287",
    "data-name": "Path 38287",
    d: "M248.858,243.825a.712.712,0,1,1-.712-.712.711.711,0,0,1,.712.712Zm.006,0a.718.718,0,1,0-.718.718.714.714,0,0,0,.718-.718Z",
    transform: "translate(-246.856 -242.481)",
    fill: "#fcc291",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12816",
    "data-name": "Group 12816",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38289",
    "data-name": "Path 38289",
    d: "M248.783,243.738a.718.718,0,1,1-.718-.718.721.721,0,0,1,.718.718Zm.006,0a.723.723,0,1,0-.723.723.723.723,0,0,0,.723-.723Z",
    transform: "translate(-246.775 -242.394)",
    fill: "#fcc290",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12817",
    "data-name": "Group 12817",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38291",
    "data-name": "Path 38291",
    d: "M248.7,243.651a.723.723,0,1,1-.723-.723.723.723,0,0,1,.723.723Zm.006,0a.729.729,0,1,0-.729.729.726.726,0,0,0,.729-.729Z",
    transform: "translate(-246.688 -242.307)",
    fill: "#fcc190",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12818",
    "data-name": "Group 12818",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38293",
    "data-name": "Path 38293",
    d: "M248.619,243.57a.729.729,0,1,1-.729-.729.726.726,0,0,1,.729.729Zm.005,0a.734.734,0,1,0-.734.734.735.735,0,0,0,.734-.734Z",
    transform: "translate(-246.601 -242.226)",
    fill: "#fcc18e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12819",
    "data-name": "Group 12819",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38295",
    "data-name": "Path 38295",
    d: "M248.542,243.483a.734.734,0,1,1-.734-.734.735.735,0,0,1,.734.734Zm.005,0a.739.739,0,1,0-.739.739.737.737,0,0,0,.739-.739Z",
    transform: "translate(-246.519 -242.14)",
    fill: "#fac08d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12820",
    "data-name": "Group 12820",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38297",
    "data-name": "Path 38297",
    d: "M248.468,243.4a.739.739,0,1,1-.739-.739.737.737,0,0,1,.739.739Zm.006,0a.745.745,0,1,0-.745.745.746.746,0,0,0,.745-.745Z",
    transform: "translate(-246.439 -242.052)",
    fill: "#fac08d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12821",
    "data-name": "Group 12821",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38299",
    "data-name": "Path 38299",
    d: "M248.38,243.315a.745.745,0,1,1-.745-.745.746.746,0,0,1,.745.745Zm.006,0a.751.751,0,1,0-.75.75.749.749,0,0,0,.75-.75Z",
    transform: "translate(-246.346 -241.971)",
    fill: "#fabe8b",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12822",
    "data-name": "Group 12822",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38301",
    "data-name": "Path 38301",
    d: "M248.305,243.228a.75.75,0,1,1-.75-.75.749.749,0,0,1,.75.75Zm.005,0a.756.756,0,1,0-.756.756.755.755,0,0,0,.756-.756Z",
    transform: "translate(-246.265 -241.884)",
    fill: "#fabe8b",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12823",
    "data-name": "Group 12823",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38303",
    "data-name": "Path 38303",
    d: "M248.229,243.147a.756.756,0,1,1-.756-.756.758.758,0,0,1,.756.756Zm.005,0a.761.761,0,1,0-.761.761.76.76,0,0,0,.761-.761Z",
    transform: "translate(-246.184 -241.803)",
    fill: "#fabd8a",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12824",
    "data-name": "Group 12824",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38305",
    "data-name": "Path 38305",
    d: "M248.146,243.06a.761.761,0,1,1-.761-.761.76.76,0,0,1,.761.761Zm.006,0a.767.767,0,1,0-.767.766.766.766,0,0,0,.767-.766Z",
    transform: "translate(-246.096 -241.716)",
    fill: "#fabd89",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12825",
    "data-name": "Group 12825",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38307",
    "data-name": "Path 38307",
    d: "M248.066,242.974a.767.767,0,1,1-.767-.766.77.77,0,0,1,.767.766Zm.005,0a.772.772,0,1,0-.772.772.772.772,0,0,0,.772-.772Z",
    transform: "translate(-246.009 -241.63)",
    fill: "#fabd87",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12826",
    "data-name": "Group 12826",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38309",
    "data-name": "Path 38309",
    d: "M247.991,242.893a.772.772,0,1,1-.772-.772.772.772,0,0,1,.772.772Zm.005,0a.777.777,0,1,0-.777.777.774.774,0,0,0,.777-.777Z",
    transform: "translate(-245.929 -241.549)",
    fill: "#fabc88",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12827",
    "data-name": "Group 12827",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38311",
    "data-name": "Path 38311",
    d: "M247.909,242.806a.777.777,0,1,1-.777-.777.781.781,0,0,1,.777.777Zm.006,0a.783.783,0,1,0-.783.783.783.783,0,0,0,.783-.783Z",
    transform: "translate(-245.842 -241.462)",
    fill: "#fabc86",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12828",
    "data-name": "Group 12828",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38313",
    "data-name": "Path 38313",
    d: "M247.828,242.718a.783.783,0,1,1-.783-.783.783.783,0,0,1,.783.783Zm.006,0a.788.788,0,1,0-.788.788.786.786,0,0,0,.788-.788Z",
    transform: "translate(-245.755 -241.374)",
    fill: "#fabb85",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12829",
    "data-name": "Group 12829",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38315",
    "data-name": "Path 38315",
    d: "M247.752,242.637a.788.788,0,1,1-.788-.788.785.785,0,0,1,.788.788Zm.005,0a.793.793,0,1,0-.793.793.794.794,0,0,0,.793-.793Z",
    transform: "translate(-245.675 -241.293)",
    fill: "#fabc85",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12830",
    "data-name": "Group 12830",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38317",
    "data-name": "Path 38317",
    d: "M247.669,242.55a.793.793,0,1,1-.793-.793.794.794,0,0,1,.793.793Zm.006,0a.8.8,0,1,0-.8.8.8.8,0,0,0,.8-.8Z",
    transform: "translate(-245.586 -241.206)",
    fill: "#faba84",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12831",
    "data-name": "Group 12831",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38319",
    "data-name": "Path 38319",
    d: "M247.589,242.469a.8.8,0,1,1-.8-.8.8.8,0,0,1,.8.8Zm.006,0a.8.8,0,1,0-.8.8.8.8,0,0,0,.8-.8Z",
    transform: "translate(-245.501 -241.125)",
    fill: "#faba82",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12832",
    "data-name": "Group 12832",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38321",
    "data-name": "Path 38321",
    d: "M247.514,242.377a.8.8,0,1,1-.8-.8.806.806,0,0,1,.8.8Zm.005,0a.809.809,0,1,0-.809.81.809.809,0,0,0,.809-.81Z",
    transform: "translate(-245.42 -241.033)",
    fill: "#fab983",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12833",
    "data-name": "Group 12833",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38323",
    "data-name": "Path 38323",
    d: "M247.438,242.3a.809.809,0,1,1-.809-.81.808.808,0,0,1,.809.81Zm.006,0a.815.815,0,1,0-.815.815.814.814,0,0,0,.815-.815Z",
    transform: "translate(-245.339 -240.952)",
    fill: "#fab982",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12834",
    "data-name": "Group 12834",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38325",
    "data-name": "Path 38325",
    d: "M247.35,242.209a.815.815,0,1,1-.815-.815.818.818,0,0,1,.815.815Zm.006,0a.821.821,0,1,0-.821.821.82.82,0,0,0,.821-.821Z",
    transform: "translate(-245.245 -240.865)",
    fill: "#fab881",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12835",
    "data-name": "Group 12835",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38327",
    "data-name": "Path 38327",
    d: "M247.274,242.127a.821.821,0,1,1-.821-.821.821.821,0,0,1,.821.821Zm.005,0a.826.826,0,1,0-.826.826.822.822,0,0,0,.826-.826Z",
    transform: "translate(-245.164 -240.783)",
    fill: "#fab87f",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12836",
    "data-name": "Group 12836",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38329",
    "data-name": "Path 38329",
    d: "M247.2,242.04a.826.826,0,1,1-.826-.826.829.829,0,0,1,.826.826Zm.006,0a.831.831,0,1,0-.831.831.832.832,0,0,0,.831-.831Z",
    transform: "translate(-245.083 -240.696)",
    fill: "#fab77e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12837",
    "data-name": "Group 12837",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38331",
    "data-name": "Path 38331",
    d: "M247.117,241.955a.831.831,0,1,1-.831-.831.832.832,0,0,1,.831.831Zm.005,0a.837.837,0,1,0-.837.836.834.834,0,0,0,.837-.836Z",
    transform: "translate(-244.996 -240.611)",
    fill: "#fab77e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12838",
    "data-name": "Group 12838",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38333",
    "data-name": "Path 38333",
    d: "M247.037,241.873a.837.837,0,1,1-.837-.837.834.834,0,0,1,.837.837Zm.005,0a.842.842,0,1,0-.842.842.843.843,0,0,0,.842-.842Z",
    transform: "translate(-244.91 -240.529)",
    fill: "#fab67d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12839",
    "data-name": "Group 12839",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38335",
    "data-name": "Path 38335",
    d: "M246.961,241.786a.842.842,0,1,1-.842-.842.843.843,0,0,1,.842.842Zm.005,0a.847.847,0,1,0-.847.847.845.845,0,0,0,.847-.847Z",
    transform: "translate(-244.829 -240.443)",
    fill: "#fab67d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12840",
    "data-name": "Group 12840",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38337",
    "data-name": "Path 38337",
    d: "M246.879,241.7a.847.847,0,1,1-.847-.847.845.845,0,0,1,.847.847Zm.006,0a.853.853,0,1,0-.853.853.854.854,0,0,0,.853-.853Z",
    transform: "translate(-244.742 -240.361)",
    fill: "#f9b57c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12841",
    "data-name": "Group 12841",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38339",
    "data-name": "Path 38339",
    d: "M246.8,241.617a.853.853,0,1,1-.853-.853.854.854,0,0,1,.853.853Zm.006,0a.858.858,0,1,0-.858.858.857.857,0,0,0,.858-.858Z",
    transform: "translate(-244.655 -240.273)",
    fill: "#f8b57b",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12842",
    "data-name": "Group 12842",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38341",
    "data-name": "Path 38341",
    d: "M246.721,241.53a.858.858,0,1,1-.858-.858.857.857,0,0,1,.858.858Zm.005,0a.863.863,0,1,0-.863.864.862.862,0,0,0,.863-.864Z",
    transform: "translate(-244.573 -240.186)",
    fill: "#f8b47a",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12843",
    "data-name": "Group 12843",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38343",
    "data-name": "Path 38343",
    d: "M246.638,241.449a.863.863,0,1,1-.863-.864.866.866,0,0,1,.863.864Zm.006,0a.869.869,0,1,0-.869.869.868.868,0,0,0,.869-.869Z",
    transform: "translate(-244.485 -240.105)",
    fill: "#f8b479",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12844",
    "data-name": "Group 12844",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38345",
    "data-name": "Path 38345",
    d: "M246.558,241.363a.869.869,0,1,1-.869-.869.868.868,0,0,1,.869.869Zm.005,0a.874.874,0,1,0-.874.874.871.871,0,0,0,.874-.874Z",
    transform: "translate(-244.4 -240.02)",
    fill: "#f8b379",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12845",
    "data-name": "Group 12845",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38347",
    "data-name": "Path 38347",
    d: "M246.483,241.276a.874.874,0,1,1-.874-.874.878.878,0,0,1,.874.874Zm.005,0a.88.88,0,1,0-.879.88.88.88,0,0,0,.879-.88Z",
    transform: "translate(-244.319 -239.932)",
    fill: "#f8b378",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12846",
    "data-name": "Group 12846",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38349",
    "data-name": "Path 38349",
    d: "M246.4,241.2a.88.88,0,1,1-.879-.88.88.88,0,0,1,.879.88Zm.006,0a.885.885,0,1,0-.885.885.882.882,0,0,0,.885-.885Z",
    transform: "translate(-244.226 -239.851)",
    fill: "#f8b277",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12847",
    "data-name": "Group 12847",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38351",
    "data-name": "Path 38351",
    d: "M246.32,241.108a.885.885,0,1,1-.885-.885.882.882,0,0,1,.885.885Zm.006,0a.891.891,0,1,0-.891.891.892.892,0,0,0,.891-.891Z",
    transform: "translate(-244.145 -239.764)",
    fill: "#f8b276",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12848",
    "data-name": "Group 12848",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38353",
    "data-name": "Path 38353",
    d: "M246.243,241.027a.891.891,0,1,1-.891-.891.892.892,0,0,1,.891.891Zm.005,0a.9.9,0,1,0-.9.9.894.894,0,0,0,.9-.9Z",
    transform: "translate(-244.063 -239.683)",
    fill: "#f9b175",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12849",
    "data-name": "Group 12849",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38355",
    "data-name": "Path 38355",
    d: "M246.161,240.939a.9.9,0,1,1-.9-.9.894.894,0,0,1,.9.9Zm.005,0a.9.9,0,1,0-.9.9.9.9,0,0,0,.9-.9Z",
    transform: "translate(-243.976 -239.596)",
    fill: "#f9b174",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12850",
    "data-name": "Group 12850",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38357",
    "data-name": "Path 38357",
    d: "M246.081,240.854a.9.9,0,1,1-.9-.9.9.9,0,0,1,.9.9Zm.006,0a.907.907,0,1,0-.907.907.905.905,0,0,0,.907-.907Z",
    transform: "translate(-243.89 -239.51)",
    fill: "#f9b074",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12851",
    "data-name": "Group 12851",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38359",
    "data-name": "Path 38359",
    d: "M246.006,240.772a.907.907,0,1,1-.907-.907.905.905,0,0,1,.907.907Zm.005,0a.912.912,0,1,0-.912.912.911.911,0,0,0,.912-.912Z",
    transform: "translate(-243.809 -239.428)",
    fill: "#f9b073",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12852",
    "data-name": "Group 12852",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38361",
    "data-name": "Path 38361",
    d: "M245.924,240.686a.912.912,0,1,1-.912-.912.914.914,0,0,1,.912.912Zm.005,0a.917.917,0,1,0-.917.918.917.917,0,0,0,.917-.918Z",
    transform: "translate(-243.723 -239.342)",
    fill: "#f9b072",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12853",
    "data-name": "Group 12853",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38363",
    "data-name": "Path 38363",
    d: "M245.842,240.6a.917.917,0,1,1-.917-.918.917.917,0,0,1,.917.918Zm.006,0a.923.923,0,1,0-.923.923.923.923,0,0,0,.923-.923Z",
    transform: "translate(-243.635 -239.254)",
    fill: "#f9af72",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12854",
    "data-name": "Group 12854",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38365",
    "data-name": "Path 38365",
    d: "M245.766,240.517a.923.923,0,1,1-.923-.923.926.926,0,0,1,.923.923Zm.005,0a.928.928,0,1,0-.928.928.928.928,0,0,0,.928-.928Z",
    transform: "translate(-243.554 -239.173)",
    fill: "#f9af70",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12855",
    "data-name": "Group 12855",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38367",
    "data-name": "Path 38367",
    d: "M245.684,240.43a.928.928,0,1,1-.928-.928.928.928,0,0,1,.928.928Zm.005,0a.934.934,0,1,0-.933.934.93.93,0,0,0,.933-.934Z",
    transform: "translate(-243.466 -239.086)",
    fill: "#f9af6f",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12856",
    "data-name": "Group 12856",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38369",
    "data-name": "Path 38369",
    d: "M245.6,240.349a.934.934,0,1,1-.933-.934.937.937,0,0,1,.933.934Zm.006,0a.939.939,0,1,0-.939.939.94.94,0,0,0,.939-.939Z",
    transform: "translate(-243.381 -239.005)",
    fill: "#f9ad70",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12857",
    "data-name": "Group 12857",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38371",
    "data-name": "Path 38371",
    d: "M245.528,240.262a.939.939,0,1,1-.939-.939.94.94,0,0,1,.939.939Zm.005,0a.945.945,0,1,0-.944.944.942.942,0,0,0,.944-.944Z",
    transform: "translate(-243.299 -238.919)",
    fill: "#f9ad6e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12858",
    "data-name": "Group 12858",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38373",
    "data-name": "Path 38373",
    d: "M245.452,240.175a.945.945,0,1,1-.944-.944.942.942,0,0,1,.944.944Zm.006,0a.95.95,0,1,0-.95.95.952.952,0,0,0,.95-.95Z",
    transform: "translate(-243.218 -238.831)",
    fill: "#f9ad6e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12859",
    "data-name": "Group 12859",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38375",
    "data-name": "Path 38375",
    d: "M245.366,240.094a.95.95,0,1,1-.95-.95.952.952,0,0,1,.95.95Zm.006,0a.956.956,0,1,0-.956.955.954.954,0,0,0,.956-.955Z",
    transform: "translate(-243.126 -238.75)",
    fill: "#f9ac6d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12860",
    "data-name": "Group 12860",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38377",
    "data-name": "Path 38377",
    d: "M245.289,240.008a.956.956,0,1,1-.956-.955.954.954,0,0,1,.956.955Zm.005,0a.961.961,0,1,0-.961.961.959.959,0,0,0,.961-.961Z",
    transform: "translate(-243.044 -238.664)",
    fill: "#f9ac6c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12861",
    "data-name": "Group 12861",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38379",
    "data-name": "Path 38379",
    d: "M245.213,239.92a.961.961,0,1,1-.961-.961.963.963,0,0,1,.961.961Zm.005,0a.966.966,0,1,0-.966.966.965.965,0,0,0,.966-.966Z",
    transform: "translate(-242.962 -238.576)",
    fill: "#f8ac6b",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12862",
    "data-name": "Group 12862",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38381",
    "data-name": "Path 38381",
    d: "M245.133,239.84a.966.966,0,1,1-.966-.966.965.965,0,0,1,.966.966Zm.006,0a.972.972,0,1,0-.972.971.971.971,0,0,0,.972-.971Z",
    transform: "translate(-242.877 -238.496)",
    fill: "#f8ac6b",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12863",
    "data-name": "Group 12863",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38383",
    "data-name": "Path 38383",
    d: "M245.051,239.753a.972.972,0,1,1-.972-.971.974.974,0,0,1,.972.971Zm.005,0a.977.977,0,1,0-.977.977.977.977,0,0,0,.977-.977Z",
    transform: "translate(-242.789 -238.409)",
    fill: "#f8ab6a",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12864",
    "data-name": "Group 12864",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38385",
    "data-name": "Path 38385",
    d: "M244.975,239.671a.977.977,0,1,1-.977-.977.977.977,0,0,1,.977.977Zm.005,0a.982.982,0,1,0-.982.982.978.978,0,0,0,.982-.982Z",
    transform: "translate(-242.708 -238.327)",
    fill: "#f8ab69",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12865",
    "data-name": "Group 12865",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38387",
    "data-name": "Path 38387",
    d: "M244.893,239.585a.982.982,0,1,1-.982-.982.986.986,0,0,1,.982.982Zm.006,0a.988.988,0,1,0-.988.988.988.988,0,0,0,.988-.988Z",
    transform: "translate(-242.621 -238.241)",
    fill: "#f8aa68",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12866",
    "data-name": "Group 12866",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38389",
    "data-name": "Path 38389",
    d: "M244.812,239.5a.988.988,0,1,1-.988-.988.988.988,0,0,1,.988.988Zm.005,0a.993.993,0,1,0-.993.993.99.99,0,0,0,.993-.993Z",
    transform: "translate(-242.535 -238.153)",
    fill: "#f8aa67",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12867",
    "data-name": "Group 12867",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38391",
    "data-name": "Path 38391",
    d: "M244.736,239.416a.993.993,0,1,1-.993-.993.99.99,0,0,1,.993.993Zm.005,0a1,1,0,1,0-1,1,1,1,0,0,0,1-1Z",
    transform: "translate(-242.453 -238.072)",
    fill: "#f8a866",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12868",
    "data-name": "Group 12868",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38393",
    "data-name": "Path 38393",
    d: "M244.655,239.33a1,1,0,1,1-1-1,1,1,0,0,1,1,1Zm.006,0a1,1,0,1,0-1,1,1,1,0,0,0,1-1Z",
    transform: "translate(-242.367 -237.986)",
    fill: "#f8a866",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12869",
    "data-name": "Group 12869",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38395",
    "data-name": "Path 38395",
    d: "M244.573,239.242a1,1,0,1,1-1-1,1,1,0,0,1,1,1Zm.006,0a1.009,1.009,0,1,0-1.009,1.009,1.012,1.012,0,0,0,1.009-1.009Z",
    transform: "translate(-242.28 -237.899)",
    fill: "#f8a865",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12870",
    "data-name": "Group 12870",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38397",
    "data-name": "Path 38397",
    d: "M244.5,239.156a1.009,1.009,0,1,1-1.009-1.009,1.011,1.011,0,0,1,1.009,1.009Zm.005,0a1.015,1.015,0,1,0-1.015,1.014,1.014,1.014,0,0,0,1.015-1.014Z",
    transform: "translate(-242.198 -237.812)",
    fill: "#f8a864",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12871",
    "data-name": "Group 12871",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38399",
    "data-name": "Path 38399",
    d: "M244.416,239.074a1.015,1.015,0,1,1-1.014-1.015,1.013,1.013,0,0,1,1.014,1.015Zm.006,0a1.02,1.02,0,1,0-1.02,1.02,1.019,1.019,0,0,0,1.02-1.02Z",
    transform: "translate(-242.111 -237.73)",
    fill: "#f8a663",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12872",
    "data-name": "Group 12872",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38401",
    "data-name": "Path 38401",
    d: "M244.335,238.988a1.02,1.02,0,1,1-1.02-1.02,1.023,1.023,0,0,1,1.02,1.02Zm.006,0a1.026,1.026,0,1,0-1.026,1.026,1.025,1.025,0,0,0,1.026-1.026Z",
    transform: "translate(-242.025 -237.644)",
    fill: "#f8a762",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12873",
    "data-name": "Group 12873",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38403",
    "data-name": "Path 38403",
    d: "M244.258,238.9a1.026,1.026,0,1,1-1.026-1.026,1.025,1.025,0,0,1,1.026,1.026Zm.005,0a1.031,1.031,0,1,0-1.031,1.031,1.028,1.028,0,0,0,1.031-1.031Z",
    transform: "translate(-241.942 -237.557)",
    fill: "#f8a561",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12874",
    "data-name": "Group 12874",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38405",
    "data-name": "Path 38405",
    d: "M244.183,238.82a1.031,1.031,0,1,1-1.031-1.031,1.034,1.034,0,0,1,1.031,1.031Zm.005,0a1.036,1.036,0,1,0-1.036,1.036,1.037,1.037,0,0,0,1.036-1.036Z",
    transform: "translate(-241.862 -237.476)",
    fill: "#f8a560",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12875",
    "data-name": "Group 12875",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38407",
    "data-name": "Path 38407",
    d: "M244.1,238.733a1.036,1.036,0,1,1-1.036-1.036,1.037,1.037,0,0,1,1.036,1.036Zm.006,0a1.042,1.042,0,1,0-1.042,1.042,1.039,1.039,0,0,0,1.042-1.042Z",
    transform: "translate(-241.77 -237.389)",
    fill: "#f8a55f",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12876",
    "data-name": "Group 12876",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38409",
    "data-name": "Path 38409",
    d: "M244.02,238.652a1.042,1.042,0,1,1-1.042-1.042,1.039,1.039,0,0,1,1.042,1.042Zm.005,0a1.047,1.047,0,1,0-1.047,1.047,1.048,1.048,0,0,0,1.047-1.047Z",
    transform: "translate(-241.688 -237.308)",
    fill: "#f8a55e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12877",
    "data-name": "Group 12877",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38411",
    "data-name": "Path 38411",
    d: "M243.944,238.565a1.047,1.047,0,1,1-1.047-1.047,1.048,1.048,0,0,1,1.047,1.047Zm.005,0a1.052,1.052,0,1,0-1.052,1.053,1.05,1.05,0,0,0,1.052-1.053Z",
    transform: "translate(-241.608 -237.221)",
    fill: "#f8a35d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12878",
    "data-name": "Group 12878",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38413",
    "data-name": "Path 38413",
    d: "M243.862,238.477a1.052,1.052,0,1,1-1.052-1.053,1.05,1.05,0,0,1,1.052,1.053Zm.006,0a1.058,1.058,0,1,0-1.058,1.058,1.06,1.06,0,0,0,1.058-1.058Z",
    transform: "translate(-241.52 -237.133)",
    fill: "#f8a25c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12879",
    "data-name": "Group 12879",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38415",
    "data-name": "Path 38415",
    d: "M243.78,238.4a1.058,1.058,0,1,1-1.058-1.058,1.06,1.06,0,0,1,1.058,1.058Zm.005,0a1.063,1.063,0,1,0-1.063,1.063,1.062,1.062,0,0,0,1.063-1.063Z",
    transform: "translate(-241.433 -237.052)",
    fill: "#f8a25a",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12880",
    "data-name": "Group 12880",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38417",
    "data-name": "Path 38417",
    d: "M243.7,238.311a1.063,1.063,0,1,1-1.063-1.063,1.062,1.062,0,0,1,1.063,1.063Zm.005,0a1.068,1.068,0,1,0-1.068,1.069,1.068,1.068,0,0,0,1.068-1.069Z",
    transform: "translate(-241.351 -236.967)",
    fill: "#f9a259",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12881",
    "data-name": "Group 12881",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38419",
    "data-name": "Path 38419",
    d: "M243.624,238.229a1.068,1.068,0,1,1-1.068-1.069,1.071,1.071,0,0,1,1.068,1.069Zm.006,0a1.074,1.074,0,1,0-1.074,1.074,1.073,1.073,0,0,0,1.074-1.074Z",
    transform: "translate(-241.266 -236.885)",
    fill: "#f8a259",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12882",
    "data-name": "Group 12882",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38421",
    "data-name": "Path 38421",
    d: "M243.542,238.142a1.074,1.074,0,1,1-1.074-1.074,1.073,1.073,0,0,1,1.074,1.074Zm.006,0a1.079,1.079,0,1,0-1.079,1.079,1.079,1.079,0,0,0,1.079-1.079Z",
    transform: "translate(-241.179 -236.799)",
    fill: "#f7a158",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12883",
    "data-name": "Group 12883",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38423",
    "data-name": "Path 38423",
    d: "M243.46,238.055a1.079,1.079,0,1,1-1.079-1.079,1.083,1.083,0,0,1,1.079,1.079Zm.005,0a1.085,1.085,0,1,0-1.085,1.085,1.085,1.085,0,0,0,1.085-1.085Z",
    transform: "translate(-241.091 -236.711)",
    fill: "#f7a157",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12884",
    "data-name": "Group 12884",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38425",
    "data-name": "Path 38425",
    d: "M243.385,237.974a1.085,1.085,0,1,1-1.085-1.085,1.085,1.085,0,0,1,1.085,1.085Zm.006,0a1.09,1.09,0,1,0-1.09,1.09,1.087,1.087,0,0,0,1.09-1.09Z",
    transform: "translate(-241.01 -236.63)",
    fill: "#f7a056",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12885",
    "data-name": "Group 12885",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38427",
    "data-name": "Path 38427",
    d: "M243.3,237.887a1.09,1.09,0,1,1-1.09-1.09,1.094,1.094,0,0,1,1.09,1.09Zm.006,0a1.1,1.1,0,1,0-1.1,1.1,1.1,1.1,0,0,0,1.1-1.1Z",
    transform: "translate(-240.923 -236.543)",
    fill: "#f79f55",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12886",
    "data-name": "Group 12886",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38429",
    "data-name": "Path 38429",
    d: "M243.227,237.8a1.1,1.1,0,1,1-1.1-1.1,1.1,1.1,0,0,1,1.1,1.1Zm.005,0a1.1,1.1,0,1,0-1.1,1.1,1.1,1.1,0,0,0,1.1-1.1Z",
    transform: "translate(-240.841 -236.457)",
    fill: "#f79e54",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12887",
    "data-name": "Group 12887",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38431",
    "data-name": "Path 38431",
    d: "M243.141,237.719a1.1,1.1,0,1,1-1.1-1.1,1.1,1.1,0,0,1,1.1,1.1Zm.006,0a1.107,1.107,0,1,0-1.106,1.106,1.108,1.108,0,0,0,1.106-1.106Z",
    transform: "translate(-240.751 -236.376)",
    fill: "#f79e54",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12888",
    "data-name": "Group 12888",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38433",
    "data-name": "Path 38433",
    d: "M243.065,237.633a1.107,1.107,0,1,1-1.106-1.106,1.108,1.108,0,0,1,1.106,1.106Zm.005,0a1.112,1.112,0,1,0-1.112,1.112,1.11,1.11,0,0,0,1.112-1.112Z",
    transform: "translate(-240.669 -236.289)",
    fill: "#f79e53",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12889",
    "data-name": "Group 12889",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38435",
    "data-name": "Path 38435",
    d: "M242.99,237.551a1.112,1.112,0,1,1-1.112-1.112,1.11,1.11,0,0,1,1.112,1.112Zm.005,0a1.117,1.117,0,1,0-1.117,1.117A1.116,1.116,0,0,0,243,237.551Z",
    transform: "translate(-240.588 -236.207)",
    fill: "#f89d52",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12890",
    "data-name": "Group 12890",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38437",
    "data-name": "Path 38437",
    d: "M242.908,237.465a1.117,1.117,0,1,1-1.117-1.117,1.119,1.119,0,0,1,1.117,1.117Zm.006,0a1.123,1.123,0,1,0-1.123,1.123,1.122,1.122,0,0,0,1.123-1.123Z",
    transform: "translate(-240.501 -236.121)",
    fill: "#f79c51",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12891",
    "data-name": "Group 12891",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38439",
    "data-name": "Path 38439",
    d: "M242.825,237.377a1.123,1.123,0,1,1-1.123-1.123,1.122,1.122,0,0,1,1.123,1.123Zm.006,0a1.128,1.128,0,1,0-1.128,1.128,1.128,1.128,0,0,0,1.128-1.128Z",
    transform: "translate(-240.413 -236.033)",
    fill: "#f89c50",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12892",
    "data-name": "Group 12892",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38441",
    "data-name": "Path 38441",
    d: "M242.75,237.3a1.128,1.128,0,1,1-1.128-1.128,1.131,1.131,0,0,1,1.128,1.128Zm.005,0a1.133,1.133,0,1,0-1.133,1.133,1.133,1.133,0,0,0,1.133-1.133Z",
    transform: "translate(-240.332 -235.952)",
    fill: "#f89c4f",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12893",
    "data-name": "Group 12893",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38443",
    "data-name": "Path 38443",
    d: "M242.669,237.21a1.133,1.133,0,1,1-1.133-1.133,1.133,1.133,0,0,1,1.133,1.133Zm.006,0a1.139,1.139,0,1,0-1.139,1.139,1.136,1.136,0,0,0,1.139-1.139Z",
    transform: "translate(-240.246 -235.866)",
    fill: "#f89a4e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12894",
    "data-name": "Group 12894",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38445",
    "data-name": "Path 38445",
    d: "M242.588,237.122a1.139,1.139,0,1,1-1.139-1.139,1.142,1.142,0,0,1,1.139,1.139Zm.006,0a1.144,1.144,0,1,0-1.144,1.144,1.145,1.145,0,0,0,1.144-1.144Z",
    transform: "translate(-240.16 -235.779)",
    fill: "#f89a4d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12895",
    "data-name": "Group 12895",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38447",
    "data-name": "Path 38447",
    d: "M242.513,237.042a1.144,1.144,0,1,1-1.144-1.144,1.145,1.145,0,0,1,1.144,1.144Zm.005,0a1.15,1.15,0,1,0-1.15,1.15,1.147,1.147,0,0,0,1.15-1.15Z",
    transform: "translate(-240.079 -235.698)",
    fill: "#f89a4c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12896",
    "data-name": "Group 12896",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38449",
    "data-name": "Path 38449",
    d: "M242.431,236.955a1.15,1.15,0,1,1-1.15-1.15,1.147,1.147,0,0,1,1.15,1.15Zm.005,0a1.155,1.155,0,1,0-1.155,1.155,1.156,1.156,0,0,0,1.155-1.155Z",
    transform: "translate(-239.991 -235.611)",
    fill: "#f8994c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12897",
    "data-name": "Group 12897",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38451",
    "data-name": "Path 38451",
    d: "M242.348,236.873a1.155,1.155,0,1,1-1.155-1.155,1.156,1.156,0,0,1,1.155,1.155Zm.006,0a1.161,1.161,0,1,0-1.161,1.16,1.159,1.159,0,0,0,1.161-1.16Z",
    transform: "translate(-239.903 -235.529)",
    fill: "#f8994a",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12898",
    "data-name": "Group 12898",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38453",
    "data-name": "Path 38453",
    d: "M242.272,236.786a1.161,1.161,0,1,1-1.161-1.16,1.159,1.159,0,0,1,1.161,1.16Zm.005,0a1.166,1.166,0,1,0-1.166,1.166,1.168,1.168,0,0,0,1.166-1.166Z",
    transform: "translate(-239.822 -235.442)",
    fill: "#f69849",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12899",
    "data-name": "Group 12899",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38455",
    "data-name": "Path 38455",
    d: "M242.2,236.7a1.166,1.166,0,1,1-1.166-1.166A1.168,1.168,0,0,1,242.2,236.7Zm.006,0a1.171,1.171,0,1,0-1.171,1.171A1.17,1.17,0,0,0,242.2,236.7Z",
    transform: "translate(-239.742 -235.356)",
    fill: "#f69848",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12900",
    "data-name": "Group 12900",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38457",
    "data-name": "Path 38457",
    d: "M242.11,236.618a1.171,1.171,0,1,1-1.171-1.171,1.17,1.17,0,0,1,1.171,1.171Zm.006,0a1.177,1.177,0,1,0-1.177,1.176,1.176,1.176,0,0,0,1.177-1.176Z",
    transform: "translate(-239.649 -235.275)",
    fill: "#f69647",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12901",
    "data-name": "Group 12901",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38459",
    "data-name": "Path 38459",
    d: "M242.035,236.532a1.177,1.177,0,1,1-1.177-1.176,1.179,1.179,0,0,1,1.177,1.176Zm.005,0a1.182,1.182,0,1,0-1.182,1.182,1.181,1.181,0,0,0,1.182-1.182Z",
    transform: "translate(-239.568 -235.188)",
    fill: "#f69646",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12902",
    "data-name": "Group 12902",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38461",
    "data-name": "Path 38461",
    d: "M241.959,236.445a1.182,1.182,0,1,1-1.182-1.182,1.182,1.182,0,0,1,1.182,1.182Zm.006,0a1.187,1.187,0,1,0-1.188,1.187,1.188,1.188,0,0,0,1.188-1.187Z",
    transform: "translate(-239.487 -235.101)",
    fill: "#f69644",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12903",
    "data-name": "Group 12903",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38463",
    "data-name": "Path 38463",
    d: "M241.876,236.364a1.187,1.187,0,1,1-1.188-1.188,1.191,1.191,0,0,1,1.188,1.188Zm.005,0a1.193,1.193,0,1,0-1.193,1.193,1.193,1.193,0,0,0,1.193-1.193Z",
    transform: "translate(-239.399 -235.02)",
    fill: "#f69543",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12904",
    "data-name": "Group 12904",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38465",
    "data-name": "Path 38465",
    d: "M241.8,236.276a1.193,1.193,0,1,1-1.193-1.193,1.194,1.194,0,0,1,1.193,1.193Zm.005,0a1.2,1.2,0,1,0-1.2,1.2,1.2,1.2,0,0,0,1.2-1.2Z",
    transform: "translate(-239.313 -234.932)",
    fill: "#f69542",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12905",
    "data-name": "Group 12905",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38467",
    "data-name": "Path 38467",
    d: "M241.721,236.2a1.2,1.2,0,1,1-1.2-1.2,1.2,1.2,0,0,1,1.2,1.2Zm.005,0a1.2,1.2,0,1,0-1.2,1.2,1.2,1.2,0,0,0,1.2-1.2Z",
    transform: "translate(-239.233 -234.852)",
    fill: "#f69341",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12906",
    "data-name": "Group 12906",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38469",
    "data-name": "Path 38469",
    d: "M241.638,236.109a1.2,1.2,0,1,1-1.2-1.2,1.2,1.2,0,0,1,1.2,1.2Zm.006,0a1.209,1.209,0,1,0-1.209,1.209,1.207,1.207,0,0,0,1.209-1.209Z",
    transform: "translate(-239.145 -234.765)",
    fill: "#f69340",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12907",
    "data-name": "Group 12907",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38471",
    "data-name": "Path 38471",
    d: "M241.557,236.021a1.209,1.209,0,1,1-1.209-1.209,1.207,1.207,0,0,1,1.209,1.209Zm.006,0a1.214,1.214,0,1,0-1.214,1.214,1.216,1.216,0,0,0,1.214-1.214Z",
    transform: "translate(-239.059 -234.678)",
    fill: "#f7933f",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12908",
    "data-name": "Group 12908",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38473",
    "data-name": "Path 38473",
    d: "M241.482,235.935a1.214,1.214,0,1,1-1.214-1.214,1.216,1.216,0,0,1,1.214,1.214Zm.005,0a1.22,1.22,0,1,0-1.22,1.22,1.218,1.218,0,0,0,1.22-1.22Z",
    transform: "translate(-238.978 -234.591)",
    fill: "#f7923e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12909",
    "data-name": "Group 12909",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38475",
    "data-name": "Path 38475",
    d: "M241.4,235.854a1.22,1.22,0,1,1-1.22-1.22,1.218,1.218,0,0,1,1.22,1.22Zm.005,0a1.225,1.225,0,1,0-1.225,1.225,1.224,1.224,0,0,0,1.225-1.225Z",
    transform: "translate(-238.89 -234.51)",
    fill: "#f7923c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12910",
    "data-name": "Group 12910",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38477",
    "data-name": "Path 38477",
    d: "M241.317,235.767a1.225,1.225,0,1,1-1.225-1.225,1.228,1.228,0,0,1,1.225,1.225Zm.006,0A1.231,1.231,0,1,0,240.092,237a1.23,1.23,0,0,0,1.231-1.231Z",
    transform: "translate(-238.802 -234.423)",
    fill: "#f7913b",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12911",
    "data-name": "Group 12911",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38479",
    "data-name": "Path 38479",
    d: "M241.243,235.68a1.231,1.231,0,1,1-1.231-1.231,1.23,1.23,0,0,1,1.231,1.231Zm.005,0a1.236,1.236,0,1,0-1.236,1.236,1.236,1.236,0,0,0,1.236-1.236Z",
    transform: "translate(-238.723 -234.336)",
    fill: "#f7913b",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12912",
    "data-name": "Group 12912",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38481",
    "data-name": "Path 38481",
    d: "M241.161,235.6a1.236,1.236,0,1,1-1.236-1.236,1.239,1.239,0,0,1,1.236,1.236Zm.006,0a1.241,1.241,0,1,0-1.241,1.241,1.241,1.241,0,0,0,1.241-1.241Z",
    transform: "translate(-238.636 -234.255)",
    fill: "#f7903a",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12913",
    "data-name": "Group 12913",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38483",
    "data-name": "Path 38483",
    d: "M241.079,235.512a1.241,1.241,0,1,1-1.241-1.241,1.241,1.241,0,0,1,1.241,1.241Zm.006,0a1.247,1.247,0,1,0-1.247,1.247,1.244,1.244,0,0,0,1.247-1.247Z",
    transform: "translate(-238.548 -234.168)",
    fill: "#f79039",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12914",
    "data-name": "Group 12914",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38485",
    "data-name": "Path 38485",
    d: "M241,235.43a1.247,1.247,0,1,1-1.247-1.247A1.251,1.251,0,0,1,241,235.43Zm.005,0a1.252,1.252,0,1,0-1.252,1.252,1.253,1.253,0,0,0,1.252-1.252Z",
    transform: "translate(-238.467 -234.086)",
    fill: "#f58e38",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12915",
    "data-name": "Group 12915",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38487",
    "data-name": "Path 38487",
    d: "M240.928,235.344a1.252,1.252,0,1,1-1.252-1.252,1.253,1.253,0,0,1,1.252,1.252Zm.005,0a1.257,1.257,0,1,0-1.258,1.258,1.256,1.256,0,0,0,1.258-1.258Z",
    transform: "translate(-238.387 -234)",
    fill: "#f78e36",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12916",
    "data-name": "Group 12916",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38489",
    "data-name": "Path 38489",
    d: "M240.841,235.257A1.257,1.257,0,1,1,239.583,234a1.256,1.256,0,0,1,1.258,1.258Zm.005,0a1.263,1.263,0,1,0-1.263,1.263,1.265,1.265,0,0,0,1.263-1.263Z",
    transform: "translate(-238.293 -233.913)",
    fill: "#f78e35",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12917",
    "data-name": "Group 12917",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38491",
    "data-name": "Path 38491",
    d: "M240.766,235.176a1.263,1.263,0,1,1-1.263-1.263,1.265,1.265,0,0,1,1.263,1.263Zm.005,0a1.268,1.268,0,1,0-1.268,1.268,1.267,1.267,0,0,0,1.268-1.268Z",
    transform: "translate(-238.214 -233.832)",
    fill: "#f68d34",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12918",
    "data-name": "Group 12918",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38493",
    "data-name": "Path 38493",
    d: "M240.691,235.09a1.268,1.268,0,1,1-1.268-1.268,1.267,1.267,0,0,1,1.268,1.268Zm.005,0a1.273,1.273,0,1,0-1.273,1.274,1.276,1.276,0,0,0,1.273-1.274Z",
    transform: "translate(-238.133 -233.746)",
    fill: "#f68d33",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12919",
    "data-name": "Group 12919",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38495",
    "data-name": "Path 38495",
    d: "M240.608,235a1.273,1.273,0,1,1-1.273-1.274A1.276,1.276,0,0,1,240.608,235Zm.006,0a1.279,1.279,0,1,0-1.279,1.279A1.279,1.279,0,0,0,240.614,235Z",
    transform: "translate(-238.045 -233.658)",
    fill: "#f68b32",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12920",
    "data-name": "Group 12920",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38497",
    "data-name": "Path 38497",
    d: "M240.527,234.921a1.279,1.279,0,1,1-1.279-1.279,1.278,1.278,0,0,1,1.279,1.279Zm.005,0a1.285,1.285,0,1,0-1.284,1.285,1.284,1.284,0,0,0,1.284-1.285Z",
    transform: "translate(-237.958 -233.577)",
    fill: "#f68b31",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12921",
    "data-name": "Group 12921",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38499",
    "data-name": "Path 38499",
    d: "M240.451,234.834a1.284,1.284,0,1,1-1.284-1.285,1.288,1.288,0,0,1,1.284,1.285Zm.005,0a1.29,1.29,0,1,0-1.29,1.29,1.29,1.29,0,0,0,1.29-1.29Z",
    transform: "translate(-237.877 -233.49)",
    fill: "#f68a2f",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12922",
    "data-name": "Group 12922",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38501",
    "data-name": "Path 38501",
    d: "M240.363,234.753a1.29,1.29,0,1,1-1.29-1.29,1.29,1.29,0,0,1,1.29,1.29Zm.006,0a1.3,1.3,0,1,0-1.3,1.3,1.292,1.292,0,0,0,1.3-1.3Z",
    transform: "translate(-237.784 -233.409)",
    fill: "#f68a2e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12923",
    "data-name": "Group 12923",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38503",
    "data-name": "Path 38503",
    d: "M240.289,234.667a1.3,1.3,0,1,1-1.3-1.3,1.3,1.3,0,0,1,1.3,1.3Zm.006,0a1.3,1.3,0,1,0-1.3,1.3,1.3,1.3,0,0,0,1.3-1.3Z",
    transform: "translate(-237.704 -233.323)",
    fill: "#f6892d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12924",
    "data-name": "Group 12924",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38505",
    "data-name": "Path 38505",
    d: "M240.213,234.58a1.3,1.3,0,1,1-1.3-1.3,1.3,1.3,0,0,1,1.3,1.3Zm.005,0a1.306,1.306,0,1,0-1.306,1.306,1.3,1.3,0,0,0,1.306-1.306Z",
    transform: "translate(-237.622 -233.236)",
    fill: "#f6882c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12925",
    "data-name": "Group 12925",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38507",
    "data-name": "Path 38507",
    d: "M240.125,234.5a1.306,1.306,0,1,1-1.306-1.306,1.3,1.3,0,0,1,1.306,1.306Zm.006,0a1.312,1.312,0,1,0-1.311,1.311,1.313,1.313,0,0,0,1.311-1.311Z",
    transform: "translate(-237.529 -233.155)",
    fill: "#f6882a",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12926",
    "data-name": "Group 12926",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38509",
    "data-name": "Path 38509",
    d: "M240.049,234.411a1.312,1.312,0,1,1-1.311-1.311,1.313,1.313,0,0,1,1.311,1.311Zm.005,0a1.317,1.317,0,1,0-1.317,1.317,1.315,1.315,0,0,0,1.317-1.317Z",
    transform: "translate(-237.448 -233.067)",
    fill: "#f68729",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12927",
    "data-name": "Group 12927",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38511",
    "data-name": "Path 38511",
    d: "M239.973,234.324a1.317,1.317,0,1,1-1.317-1.317,1.315,1.315,0,0,1,1.317,1.317Zm.005,0a1.322,1.322,0,1,0-1.322,1.322,1.324,1.324,0,0,0,1.322-1.322Z",
    transform: "translate(-237.367 -232.98)",
    fill: "#f68728",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12928",
    "data-name": "Group 12928",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38513",
    "data-name": "Path 38513",
    d: "M239.892,234.243a1.322,1.322,0,1,1-1.322-1.323,1.324,1.324,0,0,1,1.322,1.323Zm.006,0a1.328,1.328,0,1,0-1.328,1.328,1.327,1.327,0,0,0,1.328-1.328Z",
    transform: "translate(-237.28 -232.899)",
    fill: "#f68627",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12929",
    "data-name": "Group 12929",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38515",
    "data-name": "Path 38515",
    d: "M239.811,234.157a1.328,1.328,0,1,1-1.328-1.328,1.327,1.327,0,0,1,1.328,1.328Zm.005,0a1.333,1.333,0,1,0-1.333,1.333,1.333,1.333,0,0,0,1.333-1.333Z",
    transform: "translate(-237.194 -232.813)",
    fill: "#f68626",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12930",
    "data-name": "Group 12930",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38517",
    "data-name": "Path 38517",
    d: "M239.736,234.075a1.33,1.33,0,1,1-1.333-1.333,1.336,1.336,0,0,1,1.333,1.333Zm.005,0a1.338,1.338,0,1,0-1.338,1.338,1.338,1.338,0,0,0,1.338-1.338Z",
    transform: "translate(-237.113 -232.731)",
    fill: "#f48525",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12931",
    "data-name": "Group 12931",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38519",
    "data-name": "Path 38519",
    d: "M239.654,233.989a1.336,1.336,0,1,1-1.338-1.338,1.338,1.338,0,0,1,1.338,1.338Zm.006,0a1.344,1.344,0,1,0-1.344,1.344,1.344,1.344,0,0,0,1.344-1.344Z",
    transform: "translate(-237.026 -232.645)",
    fill: "#f48424",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12932",
    "data-name": "Group 12932",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38521",
    "data-name": "Path 38521",
    d: "M239.573,233.9a1.341,1.341,0,1,1-1.344-1.344,1.348,1.348,0,0,1,1.344,1.344Zm.005,0a1.349,1.349,0,1,0-1.349,1.349,1.35,1.35,0,0,0,1.349-1.349Z",
    transform: "translate(-236.939 -232.558)",
    fill: "#f48423",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12933",
    "data-name": "Group 12933",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38523",
    "data-name": "Path 38523",
    d: "M239.5,233.821a1.347,1.347,0,1,1-1.349-1.349,1.35,1.35,0,0,1,1.349,1.349Zm.005,0a1.355,1.355,0,1,0-1.355,1.355,1.352,1.352,0,0,0,1.355-1.355Z",
    transform: "translate(-236.857 -232.477)",
    fill: "#f48422",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12934",
    "data-name": "Group 12934",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38525",
    "data-name": "Path 38525",
    d: "M239.414,233.733a1.352,1.352,0,1,1-1.355-1.355,1.359,1.359,0,0,1,1.355,1.355Zm.006,0a1.36,1.36,0,1,0-1.36,1.36,1.361,1.361,0,0,0,1.36-1.36Z",
    transform: "translate(-236.77 -232.389)",
    fill: "#f48422",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12935",
    "data-name": "Group 12935",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38527",
    "data-name": "Path 38527",
    d: "M239.334,233.652a1.357,1.357,0,1,1-1.36-1.36,1.361,1.361,0,0,1,1.36,1.36Zm.006,0a1.366,1.366,0,1,0-1.366,1.365,1.364,1.364,0,0,0,1.366-1.365Z",
    transform: "translate(-236.684 -232.308)",
    fill: "#f48221",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12936",
    "data-name": "Group 12936",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38529",
    "data-name": "Path 38529",
    d: "M239.258,233.566a1.363,1.363,0,1,1-1.366-1.365,1.364,1.364,0,0,1,1.366,1.365Zm.005,0a1.371,1.371,0,1,0-1.371,1.371,1.373,1.373,0,0,0,1.371-1.371Z",
    transform: "translate(-236.603 -232.222)",
    fill: "#f48220",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12937",
    "data-name": "Group 12937",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38531",
    "data-name": "Path 38531",
    d: "M239.264,233.566a1.368,1.368,0,1,1-1.371-1.371,1.373,1.373,0,0,1,1.371,1.371Zm.006,0a1.374,1.374,0,1,0-1.376,1.376,1.371,1.371,0,0,0,1.376-1.376Z",
    transform: "translate(-236.603 -232.222)",
    fill: "#f48220",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_38533",
    "data-name": "Path 38533",
    d: "M113.752,233.458h-.772v2.693h.766a1.4,1.4,0,0,0,.961-.313,1.345,1.345,0,0,0-.956-2.38Zm.616,2.024a1.011,1.011,0,0,1-.718.21h-.141v-1.776h.141a.972.972,0,0,1,.718.216.913.913,0,0,1,.286.669.939.939,0,0,1-.286.68Z",
    transform: "translate(-107.192 -225.832)",
    fill: "#081a23",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4592",
    "data-name": "Rectangle 4592",
    width: 0.523,
    height: 2.693,
    transform: "translate(8.244 7.626)",
    fill: "#081a23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38534",
    "data-name": "Path 38534",
    d: "M167.178,233.815c-.313-.118-.41-.194-.41-.34,0-.167.167-.3.394-.3a.541.541,0,0,1,.421.216l.275-.356a1.171,1.171,0,0,0-.788-.3.793.793,0,0,0-.842.772c0,.373.173.561.664.734a2.335,2.335,0,0,1,.361.157.323.323,0,0,1,.157.275.379.379,0,0,1-.4.378.615.615,0,0,1-.572-.356l-.34.329a1.059,1.059,0,0,0,.934.513.869.869,0,0,0,.923-.885c0-.426-.173-.621-.771-.837Z",
    transform: "translate(-157.126 -225.153)",
    fill: "#081a23",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38535",
    "data-name": "Path 38535",
    d: "M199.908,233.874a1.394,1.394,0,0,0,1.42,1.4,1.45,1.45,0,0,0,.658-.156V234.5a.847.847,0,0,1-.637.3.877.877,0,0,1-.9-.928.877.877,0,0,1,1.538-.621v-.616a1.332,1.332,0,0,0-.648-.167,1.414,1.414,0,0,0-1.43,1.408Z",
    transform: "translate(-188.918 -224.899)",
    fill: "#081a23",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38536",
    "data-name": "Path 38536",
    d: "M285.33,235.266l-.718-1.808h-.573l1.139,2.758h.281l1.161-2.758h-.567Z",
    transform: "translate(-268.014 -225.832)",
    fill: "#081a23",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38537",
    "data-name": "Path 38537",
    d: "M331.2,236.151h1.484v-.459h-.961v-.723h.923v-.459h-.923v-.594h.961v-.458H331.2Z",
    transform: "translate(-312.356 -225.832)",
    fill: "#081a23",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38538",
    "data-name": "Path 38538",
    d: "M363.506,234.257c0-.507-.351-.8-.956-.8h-.777v2.693h.524v-1.085h.07l.729,1.085h.642l-.847-1.133a.718.718,0,0,0,.615-.761Zm-1.052.442H362.3v-.815h.162c.329,0,.507.135.507.4s-.178.415-.513.415Z",
    transform: "translate(-341.094 -225.832)",
    fill: "#081a23",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38539",
    "data-name": "Path 38539",
    d: "M394.309,235.7c0-.049-.033-.076-.086-.076h-.076v.238h.054v-.092l.065.092h.07l-.076-.1a.063.063,0,0,0,.049-.065Zm-.1.032h-.01v-.064h.01c.027,0,.044.011.044.032s-.016.032-.044.032Z",
    transform: "translate(-371.531 -227.864)",
    fill: "#231f20",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38540",
    "data-name": "Path 38540",
    d: "M392.281,234.178a.207.207,0,0,0-.211.205.21.21,0,0,0,.211.205.205.205,0,0,0,0-.41Zm0,.372a.168.168,0,0,1-.167-.167.161.161,0,0,1,.167-.167.167.167,0,0,1,0,.335Z",
    transform: "translate(-369.578 -226.509)",
    fill: "#231f20",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverImg);
export default __webpack_public_path__ + "static/media/Discover - img.7a5d2fd5.svg";
export { ForwardRef as ReactComponent };